<template>
  <div class="formato-medico-container">
    <v-overlay :value="uploadingFiles" z-index="9999">
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
      <div class="mt-3" style="color: white; font-weight: bold">
        Subiendo archivos... {{ uploadingCurrent }}/{{ uploadingTotal }}
      </div>
    </v-overlay>

    <s-toolbar label="Evaluación Médica Ocupacional" v-show="isDoctor || isNurse" print @print="printPDF()"
      @exit="exitView()" :save="!isContractLocked" exit :search="false" @save="save()">
    </s-toolbar>

    <div class="formato-medico" ref="printableContent">
      <div class="watermark">DOCUMENTO CONTROLADO</div>
      <div class="page" style="page-break-after: always">
        <table class="header-table">
          <tr>
            <td style="
                width: 25%;
                vertical-align: middle;
                text-align: left;
                border: none;
                padding: 10px;
              ">
              <img src="/static/logo_sp.png" alt="Logo" style="width: 140px; height: auto" />
            </td>
            <td style="
                width: 45%;
                text-align: center;
                vertical-align: middle;
                border: none;
              ">
              <div class="title">CONSENTIMIENTO INFORMADO PARA</div>
              <div class="title">EXAMEN MÉDICO OCUPACIONAL</div>
              <div class="title">DE PRE – INGRESO</div>
            </td>
            <document-header-control param-name="PdfClinicConsent" :default-data="{
              codigo: 'SIG-ST-SO-FR-004',
              version: '05',
              fechaCreacion: '28/09/2018',
              ultimaRevision: '15/07/2025',
              paginas: '1 de 1',
              anexo: '00',
            }" />
          </tr>
        </table>

        <div style="
            padding: 20px;
            text-align: justify;
            font-size: 14px;
            line-height: 1.5;
            text-transform: uppercase;
          ">
          <p>
            Yo, <b>{{ history.NtpFullName }}</b>, identificado con DNI N° <b>{{ history.PrsDocumentNumber }}</b>,
            AUTORIZO LA REALIZACIÓN DEL EXAMEN MEDICO OCUPACIONAL DE
            PRE-INGRESO SOLICITADO POR SUNSHINE EXPORT S.A.C HABIENDO SIDO
            PREVIAMENTE INFORMADO DE LA FINALIDAD DEL MISMO.
          </p>
          <p>
            DOY FE QUE LA INFORMACIÓN QUE BRINDO DURANTE LA ENTREVISTA MÉDICA ES
            COMPLETAMENTE CIERTA (Proporcionar falsa información al empleador
            está tipificado como falta grave, según lo dispuesto en el inciso D,
            del artículo 25 del TUO de la ley de Productividad y competitividad
            laboral).
          </p>
          <p>
            ASI MISMO DOY MI CONSENTIMIENTO PARA QUE EL MÉDICO OCUPACIONAL Y
            PERSONAL DEL ÁREA DE SSO DE LA EMPRESA SUNSHINE EXPORT S.A.C
            CUSTODIE Y TENGA ACCESO A LA INFORMACIÓN BRINDADA POR MI PERSONA.
          </p>
        </div>

        <!-- FIRMA CONSENTIMIENTO -->
        <div style="
            flex: 1;
            margin-top: 80px;
            display: flex;
            justify-content: center;
          ">
          <div style="
              flex: 1;
              margin-top: 80px;
              display: flex;
              justify-content: center;
            ">
            <div style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                position: relative;
                max-width: max-content;
              ">
              <div style="
                  width: 100%;
                  height: 80px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  position: absolute;
                  top: -80px;
                ">
                <div style="width: 100%; display: flex">
                  <div style="
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      align-items: center;
                      width: 100%;
                      cursor: pointer;
                    " @click="funDialogSignaturePatient()">
                    <span v-if="!SignaturePatient && !SignaturePatientDB" style="height: 80px; width: 100%"></span>
                    <img :src="SignaturePatient" v-if="SignaturePatient" alt="Firma Paciente"
                      style="max-width: 100%; height: 80px; object-fit: contain" />
                    <img :src="SignaturePatientDB" v-if="!SignaturePatient && SignaturePatientDB" alt="Firma Paciente"
                      style="max-width: 100%; height: 80px; object-fit: contain" />
                  </div>
                  <div style="
                      width: 60px;
                      height: 80px;
                      border: 1px solid #000;
                      text-align: center;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    ">
                    <!-- fingerPrintPatient, fingerPrintPatientDB -->
                    <s-finger-print v-if="FingerPrintPatientDB && !FingerPrintPatient" contentIMG
                      :srcImg="FingerPrintPatientDB" notBtn :stylesDiv="{
                        width: '60px',
                        height: '80px',
                        cursor: 'pointer',
                      }" @fingerprintSaved="handleFingerprintPatient" />
                    <s-finger-print v-if="!FingerPrintPatientDB && !FingerPrintPatient" contentIMG notBtn :stylesDiv="{
                      width: '60px',
                      height: '80px',
                      cursor: 'pointer',
                    }" @fingerprintSaved="handleFingerprintPatient" />
                    <s-finger-print v-if="FingerPrintPatient" contentIMG :srcImg="FingerPrintPatient" notBtn :stylesDiv="{
                      width: '60px',
                      height: '80px',
                      cursor: 'pointer',
                    }" @fingerprintSaved="handleFingerprintPatient" />
                  </div>
                </div>
              </div>
              <span style="border-top: 1px solid #000">
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span style="font-weight: bold">Nombre : </span>{{ history.NtpFullName }}&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
              <span><span style="font-weight: bold">DNI : </span>{{ history.PrsDocumentNumber }}</span>
              <span><span style="font-weight: bold">Fecha : </span>{{ $fun.formatDateView(history.MevDate) }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- PÁGINA 1 -->
      <div class="page">
        <table class="header-table">
          <tr>
            <td style="
                width: 25%;
                vertical-align: middle;
                text-align: left;
                border: none;
                padding: 10px;
              ">
              <img src="/static/logo_sp.png" alt="Logo" style="width: 140px; height: auto" />
            </td>
            <td style="
                width: 45%;
                text-align: center;
                vertical-align: middle;
                border: none;
              ">
              <div class="title">FORMATO PARA EXAMEN</div>
              <div class="title">MÉDICO OCUPACIONAL DE</div>
              <div class="title">PRE – INGRESO</div>
            </td>
            <document-header-control param-name="PdfClinicHistory" :default-data="{
              codigo: 'SIG-ST-SO-FR-003',
              version: '08',
              fechaCreacion: '28/10/2018',
              ultimaRevision: '14/07/2025',
              paginas: '1 de 2',
              anexo: '00',
            }" />
          </tr>
        </table>

        <!-- TABLA PRINCIPAL DE DATOS -->
        <table class="data-table">
          <tr>
            <td colspan="9">
              <b>FECHA/HORA DE EXAMEN DE PRE INGRESO:</b>
              {{ this.$fun.formatDateView(history.MevDate) }}
              {{
                this.$fun.formatTimeShortView(
                  history.MevDate + " " + history.MevTime
                )
              }}
            </td>
            <td colspan="7">
              <b>N° DE FICHA MEDICA:</b>
              <input type="text" v-model="history.MevDocumentNumber" class="input-clean" readonly />
            </td>
          </tr>

          <!-- 1) DATOS DEL EMPLEADOR -->
          <tr>
            <td class="subtitle" colspan="16" style="text-align: center">
              1) DATOS DEL EMPLEADOR
            </td>
          </tr>
          <tr>
            <td colspan="6"><b>RAZÓN SOCIAL:</b> SUNSHINE EXPORT S.A.C.</td>
            <td colspan="10">
              <b>DIRECCIÓN:</b> CARRETERA TAMBOGRANDE LAS LOMAS KM 1077 + 179
              MTS
            </td>
          </tr>
          <tr style="text-align: center">
            <td colspan="3"><b>RUC:</b><br />20329725431</td>
            <td colspan="3"><b>TELÉFONO/FAX:</b><br />073 313709</td>
            <td colspan="3"><b>SECTOR DE ACTIVIDAD:</b><br />AGRARIO</td>
            <td colspan="3"><b>ACTIVIDAD:</b><br />AGROINDUSTRIAL</td>
            <td colspan="4"><b>LUGAR (CIIU):</b><br />TAMBOGRANDE</td>
          </tr>

          <!-- 2) DATOS PERSONALES -->
          <tr>
            <td class="subtitle" colspan="16" style="text-align: center">
              2) DATOS PERSONALES
            </td>
          </tr>
          <tr>
            <td colspan="12">
              <b>APELLIDOS Y NOMBRES:</b>
              <div>{{ history.NtpFullName }}</div>
            </td>
            <td colspan="2"><b>GÉNERO:</b></td>
            <td style="text-align: center">
              M
              <input type="radio" value="1" v-model="history.TypeSex" disabled />
            </td>
            <td style="text-align: center">
              F
              <input type="radio" value="2" v-model="history.TypeSex" disabled />
            </td>
          </tr>
          <tr>
            <td colspan="5">
              <b>FECHA DE NACIMIENTO:</b>
              {{ this.$fun.formatDateView(history.NtpBirthDate) }}
            </td>
            <td colspan="5"><b>EDAD:</b> {{ history.NtpAge }}</td>
            <td colspan="6">
              <!-- <b>ESTADO CIVIL:</b> -->
              <s-select-definition :def="1071" label="Estado civil" v-model="history.TypeCivilStatus"
                :add="$fun.isAdmin()" />
            </td>
          </tr>
          <tr>
            <td colspan="5">
              <!-- <b>GRADO DE INSTRUCCIÓN:</b> -->
              <s-select-definition :def="1066" v-model="history.TypeEducationLevel" class="input-clean"
                :disabled="!isDoctor && !isNurse" :add="$fun.isAdmin()" />
            </td>
            <td colspan="5">
              <b>DNI:</b>
              <s-toolbar-person v-if="!pHistory" :addBirthDate="true" :addTypeSex="true" :typeperson="1" :value="person ? person.PrsDocumentNumber : history.PrsDocumentNumber
                " :searchDefault="true" @returnPerson="returnPerson($event)" />
              <div v-else>{{ history.PrsDocumentNumber }}</div>
            </td>
            <td colspan="6">
              <b>CELULAR:</b>
              <input type="text" v-model="history.MevPhoneNumber" class="input-clean"
                :disabled="!isDoctor && !isNurse" />
            </td>
          </tr>
          <tr>
            <td colspan="5">
              <b>ÁREA AL QUE POSTULA:</b>
              <s-select-area label="Area" v-model="history.AreID" full noDefault :disabled="!isDoctor && !isNurse"
                @change="onAreaChanged" />
            </td>
            <td colspan="5">
              <b>PUESTO AL QUE POSTULA:</b>
              <s-select-position label="Puesto" v-model="history.PstID" full noDefault
                :disabled="!history.AreID || (!isDoctor && !isNurse)" />
              <!-- :AreID="history.AreID || 1" -->
            </td>
            <td colspan="6">
              <b>TIEMPO DE EXPERIENCIA LABORANDO:</b>
              <div style="display: flex; align-items: center">
                <s-text label="Cantidad de tiempo" type="number" v-model="history.MevExpQuantity" class="input-clean"
                  style="width: 100px; margin-right: 10px" :disabled="!isDoctor && !isNurse" />
                <s-select-definition :def="1127" v-model="history.TypeExpMesure" :disabled="!isDoctor && !isNurse"
                  clearable label="Medida de tiempo" />
              </div>
            </td>
          </tr>
          <tr v-if="workingConditions && workingConditions.length > 0">
            <td colspan="16">
              <div class="working-conditions-container pa-3"
                style="background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; margin: 10px 0;">
                <div style="font-weight: bold; margin-bottom: 8px; color: #0f172a; font-size: 13px;">
                  CONDICIONES DE TRABAJO DEL PUESTO SELECCIONADO:
                </div>
                <table style="width: 100%; border-collapse: collapse; font-size: 12px; line-height: 1.4;">
                  <thead>
                    <tr style="border-bottom: 2px solid #cbd5e1; text-align: left; background-color: #f1f5f9;">
                      <th style="padding: 6px; font-weight: bold; text-transform: uppercase;">Condición / Requerimiento
                      </th>
                      <th style="padding: 6px; font-weight: bold; text-transform: uppercase;">Descripción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(cond, idx) in workingConditions" :key="idx" style="border-bottom: 1px solid #e2e8f0;">
                      <td style="padding: 6px; font-weight: bold; width: 40%; text-transform: uppercase;">{{
                        cond.DedDescription }}</td>
                      <td style="padding: 6px; color: #334155; text-transform: uppercase;">{{ cond.PwcDescription }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="1">
              <b>NÚMERO DE HIJOS:</b>
            </td>
            <td colspan="1">VIVOS</td>
            <td>
              <input type="number" v-model="history.MevChildLiving" class="input-clean small-input" min="0"
                :disabled="!isDoctor" @focus="selectInput($event)" />
            </td>
            <td>MUERTOS</td>
            <td>
              <input type="number" v-model="history.MevChildDead" class="input-clean small-input" min="0"
                :disabled="!isDoctor" @focus="selectInput($event)" />
            </td>
            <td colspan="2">ÓBITOS FETALES</td>
            <td>
              <input type="number" v-model="history.MevFetalDeaths" class="input-clean small-input" min="0"
                :disabled="!isDoctor" @focus="selectInput($event)" />
            </td>
            <td colspan="2">ABORTOS</td>
            <td>
              <input type="number" v-model="history.MevChildAborted" class="input-clean small-input" min="0"
                :disabled="!isDoctor" @focus="selectInput($event)" />
            </td>
            <td colspan="3">
              <b>HIJOS DEPENDIENTES</b>
            </td>
            <td colspan="2">
              <input type="number" v-model="history.MevChildDepend" class="input-clean small-input" min="0"
                :disabled="!isDoctor" @focus="selectInput($event)" />
            </td>
          </tr>

          <!-- 3) ANTECEDENTES -->
          <tr v-show="isDoctor">
            <td class="subtitle" colspan="16" style="text-align: center">
              3) ANTECEDENTES PERSONALES Y FAMILIARES PATOLÓGICOS
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="2">
              <b>ALERGIAS:</b>
            </td>
            <td colspan="1">
              <input type="checkbox" v-model="history.MevIsAllergy" :true-value="1" :false-value="0"
                :disabled="!isDoctor" :class="{ 'checkbox-unchecked': history.MevIsAllergy === 0 }"
                class="custom-checkbox" />
            </td>
            <td colspan="13">
              <div v-if="history.MevIsAllergy == 1" style="display: flex; flex-wrap: wrap">
                <div style="
                    display: flex;
                    align-items: center;
                    margin-right: 20px;
                    width: 45%;
                  ">
                  <b style="margin-right: 5px">ALIMENTARIAS:</b>

                  <input type="checkbox" v-model="history.MevFoodAllergy" :true-value="1" :false-value="0"
                    :disabled="!isDoctor" class="custom-checkbox mr-2" /><br />
                  <s-text v-if="history.MevFoodAllergy" v-model="history.MevFoodAllergyText" :disabled="!isDoctor"
                    class="input-clean" style="width: 100%" @focus="selectInput($event)" />
                </div>
                <div style="display: flex; align-items: center; width: 45%">
                  <b style="margin-right: 5px">MEDICAMENTOSAS:</b>
                  <input type="checkbox" v-model="history.MevMedicationAllergy" :true-value="1" :false-value="0"
                    :disabled="!isDoctor" class="custom-checkbox mr-2" /><br />
                  <s-text v-if="history.MevMedicationAllergy" v-model="history.MevMedicationAllergyText"
                    :disabled="!isDoctor" class="input-clean" style="width: 100%" @focus="selectInput($event)" />
                </div>
              </div>
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="2">
              <b>TBC:</b>
            </td>
            <td>
              <input type="checkbox" v-model="history.MevIsTuberculosis" :true-value="1" :false-value="0"
                :disabled="!isDoctor" :class="{
                  'checkbox-unchecked': history.MevIsTuberculosis === 0,
                }" class="custom-checkbox" />
            </td>
            <td colspan="2">
              <b>BRONQUITIS CRÓNICA:</b>
            </td>
            <td colspan="3">
              <input type="checkbox" v-model="history.MevIsChronicBronchitis" :true-value="1" :false-value="0"
                :disabled="!isDoctor" :class="{
                  'checkbox-unchecked': history.MevIsChronicBronchitis === 0,
                }" class="custom-checkbox" />
            </td>
            <td colspan="3">
              <b>CONVULSIONES:</b>
            </td>
            <td colspan="5">
              <input type="checkbox" v-model="history.MevIsSeizures" :true-value="1" :false-value="0"
                :disabled="!isDoctor" :class="{ 'checkbox-unchecked': history.MevIsSeizures === 0 }"
                class="custom-checkbox" />
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="2">
              <b>DIABETES:</b>
            </td>
            <td>
              <input type="checkbox" v-model="history.MevIsDiabetes" :true-value="1" :false-value="0"
                :disabled="!isDoctor" :class="{ 'checkbox-unchecked': history.MevIsDiabetes === 0 }"
                class="custom-checkbox" />
            </td>
            <td colspan="2">
              <b>HTA:</b>
            </td>
            <td>
              <input type="checkbox" v-model="history.MevIsBloodPressure" :true-value="1" :false-value="0"
                :disabled="!isDoctor" :class="{
                  'checkbox-unchecked': history.MevIsBloodPressure === 0,
                }" class="custom-checkbox" />
            </td>
            <td colspan="2">
              <b>NEOPLASIA:</b>
            </td>
            <td colspan="3">
              <input type="checkbox" v-model="history.MevIsNeoplasm" :true-value="1" :false-value="0"
                :disabled="!isDoctor" :class="{ 'checkbox-unchecked': history.MevIsNeoplasm === 0 }"
                class="custom-checkbox" />
            </td>
            <td colspan="3">
              <b>ASMA:</b>
            </td>
            <td colspan="2">
              <input type="checkbox" v-model="history.MevIsAsthma" :true-value="1" :false-value="0"
                :disabled="!isDoctor" :class="{ 'checkbox-unchecked': history.MevIsAsthma === 0 }"
                class="custom-checkbox" />
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="2">
              <b>HEPATITIS:</b>
            </td>
            <td>
              <input type="checkbox" v-model="history.MevIsHepatitis" :true-value="1" :false-value="0"
                :disabled="!isDoctor" :class="{ 'checkbox-unchecked': history.MevIsHepatitis === 0 }"
                class="custom-checkbox" />
            </td>
            <td colspan="2">
              <b>ETS:</b>
            </td>
            <td>
              <input type="checkbox" v-model="history.MevIsEts" :true-value="1" :false-value="0" :disabled="!isDoctor"
                :class="{ 'checkbox-unchecked': history.MevIsEts === 0 }" class="custom-checkbox" />
            </td>
            <td colspan="10">
              <b>CIRUGIAS:</b>
              <input type="text" v-model="history.MevDescriptionSurgery" class="input-clean" :disabled="disabled"
                @focus="selectInput($event)" />
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="16">
              <b>OTROS:</b>
              <textarea v-model="history.MevOtherPathology" class="input-clean" rows="2" :disabled="!isDoctor"
                @focus="selectInput($event)"></textarea>
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="16">
              <b>ANTECEDENTES FAMILIARES:</b>
              <textarea v-model="history.MevFamilyAntecedents" class="input-clean" rows="2" :disabled="!isDoctor"
                @focus="selectInput($event)"></textarea>
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td :colspan="history.TypeSex == 2 ? '12' : '16'">
              <b>OBSERVACIONES</b> (OTRAS ENFERMEDADES, MEDICAMENTOS QUE CONSUME
              HABITUALMENTE, ETC):
              <textarea v-model="history.MevObservationPathology" class="input-clean" rows="2" :disabled="!isDoctor"
                @focus="selectInput($event)"></textarea>
            </td>
            <td :colspan="history.TypeSex == 2 ? '4' : '0'" style="vertical-align: top" v-show="history.TypeSex == 2">
              <div style="margin-bottom: 10px">
                <b>FUR:</b>
                <input type="text" v-model="history.MevDateFUR" class="input-clean" label="FUR:" :disabled="!isDoctor"
                  @focus="selectInput($event)" />
              </div>
              <div>
                <b>MAC:</b>
                <input type="text" v-model="history.MevMAC" class="input-clean" :disabled="!isDoctor"
                  @focus="selectInput($event)" />
              </div>
            </td>
          </tr>

          <!-- 4) EXAMEN MENTAL -->
          <tr v-show="isDoctor">
            <td class="subtitle" colspan="16" style="text-align: center">
              4) EXAMEN MENTAL
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="8" style="
                text-align: center;
                background-color: #e9e9e9;
                font-weight: bold;
                width: 50%;
              ">
              OBSERVACIÓN DE CONDUCTAS
            </td>
            <td colspan="8" style="
                text-align: center;
                background-color: #e9e9e9;
                font-weight: bold;
                width: 50%;
              ">
              PROCESOS COGNITIVOS
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="2">PRESENTACIÓN:</td>
            <td>ADECUADO</td>
            <td>
              <input type="radio" :value="1" v-model="history.MevMentalPresentation" :disabled="!isDoctor" />
            </td>
            <td colspan="4">INADECUADO</td>
            <td>
              <input type="radio" :value="2" v-model="history.MevMentalPresentation" :disabled="!isDoctor" />
            </td>
            <td colspan="7">
              LUCIDO, ATENTO: <br />
              LOTEP
              <input type="radio" :value="1" v-model="history.MevMentalLucidity" :disabled="!isDoctor" />
              NO LOTEP
              <input type="radio" :value="0" v-model="history.MevMentalLucidity" :disabled="!isDoctor" />
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="2">POSTURA:</td>
            <td>ERGUIDA</td>
            <td>
              <input type="radio" :value="1" v-model="history.MevMentalPosture" :disabled="!isDoctor" />
            </td>
            <td colspan="4">ENCORVADA</td>
            <td>
              <input type="radio" :value="2" v-model="history.MevMentalPosture" :disabled="!isDoctor" />
            </td>
            <td colspan="7">
              PENSAMIENTO:<br />
              NORMAL
              <input type="radio" :value="1" v-model="history.MevMentalThought" :disabled="!isDoctor" />
              ALTERADO
              <input type="radio" :value="0" v-model="history.MevMentalThought" :disabled="!isDoctor" />
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="2">DISCURSO:</td>
            <td>LENTO</td>
            <td>
              <input type="radio" :value="1" v-model="history.MevMentalLanguage" :disabled="!isDoctor" />
            </td>
            <td colspan="2">MODERADO</td>
            <td>
              <input type="radio" :value="2" v-model="history.MevMentalLanguage" :disabled="!isDoctor" />
            </td>
            <td>RÁPIDO</td>
            <td>
              <input type="radio" :value="3" v-model="history.MevMentalLanguage" :disabled="!isDoctor" />
            </td>
            <td colspan="7">
              PERCEPCIÓN:<br />
              NORMAL
              <input type="radio" :value="1" v-model="history.MevMentalPerception" :disabled="!isDoctor" />
              ALTERADO
              <input type="radio" :value="0" v-model="history.MevMentalPerception" :disabled="!isDoctor" />
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="2">TONO:</td>
            <td>BAJO</td>
            <td>
              <input type="radio" :value="1" v-model="history.MevMentalPitch" :disabled="!isDoctor" />
            </td>
            <td colspan="2">MODERADO</td>
            <td>
              <input type="radio" :value="2" v-model="history.MevMentalPitch" :disabled="!isDoctor" />
            </td>
            <td>ALTO</td>
            <td>
              <input type="radio" :value="3" v-model="history.MevMentalPitch" :disabled="!isDoctor" />
            </td>
            <td>
              <b>MEMORIA:</b> <br />
              CORTO PLAZO
            </td>
            <td>
              <input type="radio" :value="1" v-model="history.MevMentalMemory" :disabled="!isDoctor" />
            </td>
            <td colspan="2">MEDIANO PLAZO</td>
            <td>
              <input type="radio" :value="2" v-model="history.MevMentalMemory" :disabled="!isDoctor" />
            </td>
            <td>
              <label for="longTermMemory">LARGO PLAZO</label>
            </td>
            <td>
              <input type="radio" :value="3" v-model="history.MevMentalMemory" name="longTermMemory"
                :disabled="!isDoctor" />
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="2">ARTICULACION</td>
            <td>SIN DIFICULTAD</td>
            <td>
              <input type="radio" :value="0" v-model="history.MevMentalArticulation" :disabled="!isDoctor" />
            </td>
            <td colspan="4">CON DIFICULTAD</td>
            <td>
              <input type="radio" :value="1" v-model="history.MevMentalArticulation" :disabled="!isDoctor" />
            </td>
            <td>
              <b>INTELIGENCIA:</b> <br />
              SUPERIOR
            </td>
            <td>
              <input type="radio" :value="1" v-model="history.MevMentalInteligence" :disabled="!isDoctor" />
            </td>
            <td colspan="2">MODERADO</td>
            <td>
              <input type="radio" :value="2" v-model="history.MevMentalInteligence" :disabled="!isDoctor" />
            </td>
            <td>
              <label for="longTermMemory">LEVE</label>
            </td>
            <td>
              <input type="radio" :value="3" v-model="history.MevMentalInteligence" name="longTermMemory"
                :disabled="!isDoctor" />
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="2">ORIENTACIÓN: TIEMPO</td>
            <td>ORIENTADO</td>
            <td>
              <input type="radio" :value="1" v-model="history.MevMentalOrientationTime" :disabled="!isDoctor" />
            </td>
            <td colspan="4">DESORIENTADO</td>
            <td>
              <input type="radio" :value="0" v-model="history.MevMentalOrientationTime" :disabled="!isDoctor" />
            </td>
            <td colspan="7">
              ANT. PSICOLOGICOS:
              <input type="text" v-model="history.MevMentalPsychologicalAnt" class="input-clean" :disabled="!isDoctor"
                @focus="selectInput($event)" />
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="2">ESPACIO:</td>
            <td>ORIENTADO</td>
            <td>
              <input type="radio" :value="1" v-model="history.MevMentalOrientationSpace" :disabled="!isDoctor" />
            </td>
            <td colspan="4">DESORIENTADO</td>
            <td>
              <input type="radio" :value="0" v-model="history.MevMentalOrientationSpace" :disabled="!isDoctor" />
            </td>
            <td colspan="7">
              ANT. PSIQUIÁTRICOS:
              <input type="text" v-model="history.MevMentalPsychiatricAnt" class="input-clean" :disabled="!isDoctor"
                @focus="selectInput($event)" />
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="2">PERSONA</td>
            <td>ORIENTADO</td>
            <td>
              <input type="radio" :value="1" v-model="history.MevMentalOrientationPerson" :disabled="!isDoctor" />
            </td>
            <td colspan="4">DESORIENTADO</td>
            <td>
              <input type="radio" :value="0" v-model="history.MevMentalOrientationPerson" :disabled="!isDoctor" />
            </td>
            <td colspan="7"></td>
          </tr>

          <!-- 5) HÁBITOS NOCIVOS -->
          <tr v-show="isDoctor">
            <td class="subtitle" colspan="16" style="text-align: center">
              5) HÁBITOS NOCIVOS
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="2">ALCOHOL</td>
            <td colspan="2">
              SI
              <input type="radio" :value="1" v-model="history.MevAlcoholType" :disabled="!isDoctor" />
              NO
              <input type="radio" :value="0" v-model="history.MevAlcoholType" :disabled="!isDoctor" />
            </td>
            <td colspan="6">
              <s-select-definition v-show="history.MevAlcoholType == 1" :def="1047" label="Tipo de Alcohol"
                :disabled="!isDoctor" v-model="history.TypeAlcohol" />
              <!-- EN CASO MARCAMOS NO, DEBEMOS MOSTRAR NIEGA -->
              <div v-show="history.MevAlcoholType == 0" style="font-weight: bold; color: #0e0e88; margin-top: 5px">
                NIEGA
              </div>
            </td>
            <td colspan="6">
              <s-select-definition v-show="history.MevAlcoholType == 1" :def="1049" :disabled="!isDoctor" clearable
                label="Frecuencia" v-model="history.TypeAlcoholFrequency" />
              <div v-show="history.MevAlcoholType == 0" style="font-weight: bold; color: #0e0e88; margin-top: 5px">
                NIEGA
              </div>
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="2">CIGARRILLO</td>
            <td colspan="2">
              SI
              <input type="radio" :value="1" v-model="history.MevTobaccoType" :disabled="!isDoctor" />
              NO
              <input type="radio" :value="0" v-model="history.MevTobaccoType" :disabled="!isDoctor" />
            </td>
            <td colspan="6">
              <s-select-definition v-show="history.MevTobaccoType == 1" :def="1048" :disabled="!isDoctor"
                v-model="history.TypeTobacco" />
              <div v-show="history.MevTobaccoType == 0" style="font-weight: bold; color: #0e0e88; margin-top: 5px">
                NIEGA
              </div>
            </td>
            <td colspan="6">
              <s-select-definition v-show="history.MevTobaccoType == 1" :def="1049" :disabled="!isDoctor"
                label="Frecuencia" v-model="history.TypeTobaccoFrequency" />
              <div v-show="history.MevTobaccoType == 0" style="font-weight: bold; color: #0e0e88; margin-top: 5px">
                NIEGA
              </div>
            </td>
          </tr>
          <!-- <tr>
            <td colspan="15">
              <label>
                <input
                  type="checkbox"
                  v-model="showAccidents"
                  :disabled="!isDoctor"
                  style="margin-right: 8px"
                />
                Mostrar sección de accidentes de trabajo o enfermedades ocupacionales
                sufridos anteriormente
              </label>
            </td>
          </tr> -->
          <!-- 6) ACCIDENTES -->
          <!-- <template v-if="showAccidents === true"> -->
          <tr v-show="isDoctor">
            <td class="subtitle" colspan="16" style="text-align: center">
              6) ACCIDENTES DE TRABAJO O ENFERMEDADES OCUPACIONALES SUFRIDOS
              ANTERIORMENTE
            </td>
          </tr>
          <tr v-show="isDoctor" style="text-align: center; font-weight: bold">
            <td colspan="3">EVENTUALIDAD</td>
            <td colspan="6">DESCRIPCIÓN</td>
            <td colspan="2">AÑO</td>
            <td colspan="5">DÍAS PERDIDOS *</td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="3">
              ACCIDENTE
              <input type="radio" :value="1" v-model="history.MevAccident1" :disabled="!isDoctor" />
              ENFERMEDAD
              <input type="radio" :value="0" v-model="history.MevAccident1" :disabled="!isDoctor" />
            </td>
            <td colspan="6">
              <s-text v-show="history.MevAccident1 !== null" :disabled="!isDoctor"
                v-model="history.MevAccidentDescription1" @focus="selectInput($event)"></s-text>
              <div v-show="history.MevAccident1 == null" style="
                  font-weight: bold;
                  color: #0e0e88;
                  margin-top: 5px;
                  text-align: center;
                ">
                NIEGA
              </div>
            </td>
            <td colspan="2">
              <s-text v-show="history.MevAccident1 !== null" :disabled="!isDoctor" number
                v-model="history.MevAccidentYear1" @focus="selectInput($event)"></s-text>
              <div v-show="history.MevAccident1 == null" style="
                  font-weight: bold;
                  color: #0e0e88;
                  margin-top: 5px;
                  text-align: center;
                ">
                NIEGA
              </div>
            </td>
            <td colspan="5">
              <s-text v-show="history.MevAccident1 !== null" :disabled="!isDoctor" number
                v-model="history.MevAccidentDaysLost1" @focus="selectInput($event)"></s-text>
              <div v-show="history.MevAccident1 == null" style="
                  font-weight: bold;
                  color: #0e0e88;
                  margin-top: 5px;
                  text-align: center;
                ">
                NIEGA
              </div>
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="3">
              ACCIDENTE
              <input type="radio" :value="1" v-model="history.MevAccident2" :disabled="!isDoctor" />
              ENFERMEDAD
              <input type="radio" :value="0" v-model="history.MevAccident2" :disabled="!isDoctor" />
            </td>
            <td colspan="6">
              <s-text v-show="history.MevAccident2 !== null" :disabled="!isDoctor"
                v-model="history.MevAccidentDescription2" @focus="selectInput($event)"></s-text>
              <div v-show="history.MevAccident2 == null" style="
                  font-weight: bold;
                  color: #0e0e88;
                  margin-top: 5px;
                  text-align: center;
                ">
                NIEGA
              </div>
            </td>
            <td colspan="2">
              <s-text v-show="history.MevAccident2 !== null" :disabled="!isDoctor" number
                v-model="history.MevAccidentYear2" @focus="selectInput($event)"></s-text>
              <div v-show="history.MevAccident2 == null" style="
                  font-weight: bold;
                  color: #0e0e88;
                  margin-top: 5px;
                  text-align: center;
                ">
                NIEGA
              </div>
            </td>
            <td colspan="5">
              <s-text v-show="history.MevAccident2 !== null" :disabled="!isDoctor" number
                v-model="history.MevAccidentDaysLost2" @focus="selectInput($event)"></s-text>
              <div v-show="history.MevAccident2 == null" style="
                  font-weight: bold;
                  color: #0e0e88;
                  margin-top: 5px;
                  text-align: center;
                ">
                NIEGA
              </div>
            </td>
          </tr>
          <!-- </template> -->
          <!-- 7) HÁBITOS DE VIDA (FUNCIONES BIOLÓGICAS) -->
          <tr v-show="isDoctor">
            <td class="subtitle" colspan="16" style="text-align: center">
              7) FUNCIONES BIOLÓGICAS
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="5">
              <s-select-definition :disabled="!isDoctor" :def="1050" v-model="history.TypeLevelAppetite"
                label="APETITO" />
            </td>
            <td colspan="5">
              <s-select-definition :def="1050" :disabled="!isDoctor" v-model="history.TypeLevelThirst" label="SED" />
            </td>
            <td colspan="6">
              <s-select-definition :def="1050" :disabled="!isDoctor" v-model="history.TypeLevelUrine" label="ORINA" />
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="5">
              <s-select-definition :def="1050" :disabled="!isDoctor" label="DEPOSICIONES"
                v-model="history.TypeLevelDepositions" />
            </td>
            <td colspan="5">
              <s-select-definition :def="1050" :disabled="!isDoctor" label="SUEÑO" v-model="history.TypeLevelSleep" />
            </td>
            <td colspan="6">
              <s-select-definition :def="1050" :disabled="!isDoctor" label="PERDIDA PESO / OBESIDAD"
                v-model="history.TypeLevelLostWeight" :default="2" />
            </td>
          </tr>
          <!-- </table>
       -->

          <!-- PÁGINA 2 -->
          <!-- <div class="page page-2"> -->
          <!-- <table class="header-table">
          <tr>
            <td
              style="
                width: 20%;
                vertical-align: middle;
                text-align: left;
                border: none;
                padding: 10px;
              "
            >
              <img src="/img/sunshine-logo.png" style="height: 70px" alt="Logo" />
            </td>
            <td
              style="
                width: 50%;
                text-align: center;
                vertical-align: middle;
                border: none;
                padding: 10px;
              "
            >
              <div class="title">FORMATO PARA EXAMEN</div>
              <div class="title">MÉDICO OCUPACIONAL DE</div>
              <div class="title">PRE – INGRESO</div>
            </td>
            <td
              style="
                width: 30%;
                vertical-align: top;
                border: none;
                font-size: 11px;
                padding: 10px;
                line-height: 1.6;
              "
            >
              <div><strong>CÓDIGO:</strong> SIG-ST-SO-FR-003</div>
              <div><strong>VERSIÓN:</strong> 08</div>
              <div><strong>Fecha de Creación:</strong> 28/10/2018</div>
              <div><strong>Última Revisión:</strong> 14/07/2025</div>
              <div><strong>Páginas:</strong> 2 de 2</div>
              <div><strong>Anexos:</strong> 00</div>
            </td>
          </tr>
        </table> -->

          <!-- <table class="data-table"> -->
          <tr>
            <td class="subtitle" colspan="16" style="text-align: center">
              8) EVALUACIÓN MÉDICA
            </td>
          </tr>
          <tr style="text-align: center">
            <td colspan="2"><b>FC (LAT/MIN)</b><br /></td>
            <td colspan="3">
              <s-text :disabled="!isDoctor && !isNurse" number v-model="history.MevHeartRate" @input="validateHeartRate"
                @focus="selectInput($event)" />
              <div style="font-size: 10px; color: gray">
                <span :style="{
                  color: getFCColor(history.MevHeartRate),
                  fontWeight: 'bold',
                }"><b>{{ getFCDescription(history.MevHeartRate) }}</b>
                </span>
              </div>
            </td>
            <td><b>FR (RESP/MIN)</b><br /></td>
            <td colspan="2">
              <s-text :disabled="!isDoctor && !isNurse" number v-model="history.MevBreathingFrecuency"
                @focus="selectInput($event)"></s-text>
              <div style="font-size: 10px; color: gray">
                <span :style="{
                  color: getFRColor(history.MevBreathingFrecuency),
                  fontWeight: 'bold',
                }"><b>{{ getFRDescription(history.MevBreathingFrecuency) }}</b>
                </span>
              </div>
            </td>
            <td colspan="2"><b>TEMP °C</b><br /></td>
            <td colspan="3">
              <s-text decimal :disabled="!isDoctor && !isNurse" v-model="history.MevTemperature"
                @focus="selectInput($event)"></s-text>
              <div style="font-size: 10px; color: gray">
                <span :style="{
                  color: getTEMPColor(history.MevTemperature),
                  fontWeight: 'bold',
                }"><b>{{ getTEMPDescription(history.MevTemperature) }}</b>
                </span>
              </div>
            </td>
            <td><b>SO2 %</b><br /></td>
            <td colspan="2">
              <s-text decimal :disabled="!isDoctor && !isNurse" v-model="history.MevOxygenSaturation"
                @focus="selectInput($event)"></s-text>
              <div style="font-size: 10px; color: gray">
                <span :style="{
                  color: getSO2Color(history.MevOxygenSaturation),
                  fontWeight: 'bold',
                }"><b>{{ getSO2Description(history.MevOxygenSaturation) }}</b>
                </span>
              </div>
            </td>
          </tr>
          <tr style="text-align: center">
            <td colspan="2"><b>PA (mmHg)</b><br /></td>
            <td colspan="3">
              <div style="display: flex; align-items: center">
                <s-text :disabled="!isDoctor && !isNurse" number v-model="history.MevPASistol" style="width: 120px"
                  @focus="selectInput($event)" />
                <br />
                <span style="margin: 0">/</span>
                <br />
                <s-text :disabled="!isDoctor && !isNurse" number v-model="history.MevPADiastol" style="width: 120px"
                  @focus="selectInput($event)" />
              </div>
              <div style="font-size: 10px; color: gray">
                <span :style="{
                  color: getPAColor(
                    history.MevPASistol,
                    history.MevPADiastol
                  ),
                  fontWeight: 'bold',
                }"><b>{{
                    getPADescription(history.MevPASistol, history.MevPADiastol)
                  }}</b>
                </span>
              </div>
            </td>
            <td><b>TALLA (cm)</b><br /></td>
            <td colspan="2">
              <s-text decimal :disabled="!isDoctor && !isNurse" v-model="history.MevSize"
                @focus="selectInput($event)"></s-text>
            </td>
            <td colspan="2"><b>PESO (Kg)</b><br /></td>
            <td colspan="3">
              <s-text decimal :disabled="!isDoctor && !isNurse" v-model="history.MevWeight"
                @focus="selectInput($event)"></s-text>
            </td>
            <td><b>IMC</b><br /></td>
            <td colspan="2">
              <span :style="{
                color: getBMIColor(history.MevBMI),
                fontWeight: 'bold',
              }">{{ history.MevBMI }}
                <b><br />
                  {{ getBMIDescription(history.MevBMI) }}</b>
              </span>
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="16" style="padding-bottom: 20px">
              <b>ANAMNESIS:</b>
              <s-select-definition :disabled="!isDoctor" clearable :def="1182" v-model="history.TypeAnamnesis"
                :add="true" />

              <textarea v-model="history.MevDescriptionAnamnesis" class="input-clean" rows="4" :disabled="!isDoctor"
                @focus="selectInput($event)"></textarea>
            </td>
          </tr>

          <!-- AGUDEZA VISUAL -->
          <tr>
            <!-- AGUDEZA LEJOS -->
            <td rowspan="2" style="text-align: center; width: 12%">
              AGUDEZA VISUAL LEJOS
            </td>

            <td style="width: 3%">OD</td>
            <td colspan="2" style="width: 10%">
              <s-select-definition :def="1185" :dgr="97" :default="2" :disabled="!isDoctor && !isNurse"
                v-model="history.MevVisualFarRight" style="min-width: 110px" />
            </td>

            <!-- CON CORRECTORES -->
            <td rowspan="2" style="text-align: center; width: 12%">
              CON CORRECTORES
            </td>

            <td style="width: 3%">OD</td>
            <td colspan="2" style="width: 10%">
              <s-select-definition :def="1185" :dgr="97" :disabled="!isDoctor && !isNurse" clearable
                v-model="history.MevVisualFarRightLense" style="min-width: 110px" />
            </td>

            <!-- AGUDEZA CERCA -->
            <td rowspan="2" style="text-align: center; width: 12%">
              AGUDEZA VISUAL CERCA
            </td>

            <td style="width: 3%">OD</td>
            <td colspan="2" style="width: 10%">
              <s-select-definition :def="1185" :disabled="!isDoctor && !isNurse" v-model="history.MevVisualNearRight"
                style="min-width: 110px" />
            </td>

            <td rowspan="2" style="text-align: center; width: 12%">
              CON CORRECTORES
            </td>

            <td style="width: 3%">OD</td>
            <td colspan="2" style="width: 10%">
              <s-select-definition :def="1185" :disabled="!isDoctor && !isNurse" clearable
                v-model="history.MevVisualNearRightLense" style="min-width: 110px" />
            </td>
          </tr>

          <tr>
            <!-- LEJOS OI -->
            <td>OI</td>
            <td colspan="2">
              <s-select-definition :def="1185" :dgr="97" :default="2" :disabled="!isDoctor && !isNurse"
                v-model="history.MevVisualFarLeft" style="min-width: 110px" />
            </td>

            <td>OI</td>
            <td colspan="2">
              <s-select-definition :def="1185" :dgr="97" :disabled="!isDoctor && !isNurse" clearable
                v-model="history.MevVisualFarLeftLense" style="min-width: 110px" />
            </td>

            <!-- CERCA OI -->
            <td>OI</td>
            <td colspan="2">
              <s-select-definition :def="1185" :disabled="!isDoctor && !isNurse" v-model="history.MevVisualNearLeft"
                style="min-width: 110px" />
            </td>

            <td>OI</td>
            <td colspan="2">
              <s-select-definition :def="1185" :disabled="!isDoctor && !isNurse" clearable
                v-model="history.MevVisualNearLeftLense" style="min-width: 110px" />
            </td>
          </tr>

          <!-- EXAMEN FÍSICO -->
          <tr v-show="isDoctor">
            <td colspan="3" class="header-cell">DETALLE</td>
            <td colspan="2" class="header-cell">REVISADO</td>
            <td colspan="11" class="header-cell">DESCRIPCIÓN</td>
          </tr>
          <tr v-show="isDoctor" v-for="(item, index) in physicalExamSystems" :key="index">
            <td colspan="3">{{ item.label }}</td>
            <td colspan="2" style="text-align: center">
              <input type="checkbox" v-model="history[item.checkField]" :true-value="1" :false-value="0"
                :disabled="!isDoctor" :class="{
                  'checkbox-unchecked': history[item.checkField] === 0,
                }" class="custom-checkbox" @focus="selectInput($event)" />
            </td>
            <td colspan="11">
              <input v-if="history[item.checkField] === 0" type="text" v-model="history[item.descField]"
                class="input-clean" :disabled="!isDoctor" :ref="`descInput-${item.descField}`"
                :placeholder="'Describa hallazgo si es anormal'" />
            </td>
          </tr>

          <!-- DIAGNÓSTICOS Y RECOMENDACIONES -->
          <tr v-show="isDoctor">
            <td colspan="7" style="vertical-align: top; height: 100px">
              <b>DIAGNÓSTICOS</b>
              <br />
              <s-select-definition multiple badgesBelow :def="1161" :disabled="!isDoctor" clearable searchable
                label="Opciones de diagnóstico" v-model="history.TypeDiagnosis" :addCustom="$fun.isAdmin()"
                :customFields="[
                  {
                    key: 'DedDescription',
                    label: 'Nombre',
                    required: true,
                    cols: 6,
                  },
                  {
                    key: 'DedHelper',
                    label: 'Sistema',
                    required: true,
                    cols: 6,
                  },
                ]" />
              <br />
              <textarea v-model="history.MevDescriptionDiagnosis" class="input-clean" rows="4" :disabled="!isDoctor"
                @focus="selectInput($event)" />
            </td>
            <td colspan="9" rowspan="2" style="vertical-align: top">
              <b>REEVALUACIÓN:</b>
              <textarea v-model="history.MevDescriptionReevaluation" class="input-clean" rows="6"
                :disabled="!isDoctor || isNurse" @focus="selectInput($event)"></textarea>
              <div class="mt-2">
                <v-file-input v-model="reevaluationFile" label="Adjuntar Archivos (Img/PDF)"
                  accept="image/*,.pdf,.doc,.docx,.rtf" multiple :disabled="!isDoctor || isNurse" dense outlined />

                <!-- Archivos ya asociados a la reevaluación -->
                <div v-if="reevaluationFiles && reevaluationFiles.length" class="mt-2"
                  style="display: flex; flex-wrap: wrap">
                  <v-chip v-for="file in reevaluationFiles" :key="file.path" small class="ma-1" outlined
                    @click="openReevaluationFile(file)">
                    <v-icon left small v-if="file.isImage">mdi-image</v-icon>
                    <v-icon left small v-else-if="file.isPdf">mdi-file-pdf-box</v-icon>
                    <v-icon left small v-else-if="file.isWord">mdi-file-word-box</v-icon>
                    <v-icon left small v-else>mdi-file</v-icon>
                    {{ file.name }}
                  </v-chip>
                </div>
              </div>
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="7" style="vertical-align: top; height: 100px">
              <b>RECOMENDACIONES:</b>
              <s-select-definition multiple badgesBelow :def="1558" :disabled="!isDoctor" clearable
                label="Opciones de recomendación" v-model="history.TypeRecommendations" :addCustom="$fun.isAdmin()"
                :customFields="[
                  {
                    key: 'DedDescription',
                    label: 'Nombre',
                    required: true,
                    cols: 6,
                  },
                ]" />
              <textarea v-model="history.MevRecommendations" class="input-clean" rows="4"
                :disabled="!isDoctor || isNurse" @focus="selectInput($event)"></textarea>
            </td>
          </tr>

          <!-- FACTORES DE RIESGO Y OTROS -->
          <tr v-show="isDoctor">
            <td class="subtitle" colspan="16" style="text-align: center">
              FACTORES DE RIESGO Y RECOMENDACIONES ADICIONALES
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="16">
              <div style="display: flex; align-items: center; margin-bottom: 5px">
                <b>FACTORES DE RIESGO:</b>
                <input type="checkbox" v-model="history.MevHasRiskFactors" :true-value="1" :false-value="0"
                  :disabled="!isDoctor || isNurse" class="custom-checkbox ml-2" style="margin-left: 10px" />
              </div>
              <s-select-definition v-if="history.MevHasRiskFactors == 1" multiple badgesBelow :def="1188"
                :disabled="!isDoctor" clearable label="Seleccione Factores de Riesgo" v-model="history.MevRiskFactors"
                :addCustom="$fun.isAdmin()" :customFields="[
                  {
                    key: 'DedDescription',
                    label: 'Nombre',
                    required: true,
                    cols: 6,
                  },
                ]" />
              <!-- ingresar un texto -->
              <textarea v-if="history.MevHasRiskFactors == 1" v-model="history.MevDescriptionRiskFactors"
                class="input-clean" rows="3" placeholder="Otros factores de riesgo (especifique)" :disabled="!isDoctor"
                @focus="selectInput($event)"></textarea>
            </td>
          </tr>
          <tr v-show="isDoctor">
            <td colspan="5">
              <b>DIETA:</b>
              <input type="checkbox" v-model="history.MevDiet" :true-value="1" :false-value="0"
                :disabled="!isDoctor || isNurse" class="custom-checkbox ml-2" style="margin-left: 10px" />
            </td>
            <td colspan="11">
              <b>GESTANTES:</b>
              <input type="checkbox" v-model="history.MevPregnant" :true-value="1" :false-value="0"
                :disabled="!isDoctor || isNurse" class="custom-checkbox ml-2" style="margin-left: 10px" />
            </td>
          </tr>

          <!-- FIRMA HISTORIA CLINICA -->
          <tr>
            <td colspan="7">
              <div style="
                  flex: 1;
                  margin-top: 80px;
                  display: flex;
                  justify-content: center;
                ">
                <!-- <p -->
                <!-- style="font-size: 12px; display: flex; flex-direction: column; justify-content: center; align-items: center; position: relative; margin: 0;"> -->
                <div style="
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    max-width: max-content;
                  ">
                  <div style="
                      width: 100%;
                      height: 80px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      position: absolute;
                      top: -80px;
                    ">
                    <div style="width: 100%; display: flex">
                      <div style="
                          display: flex;
                          flex-direction: column;
                          justify-content: center;
                          align-items: center;
                          width: 100%;
                          cursor: pointer;
                        " @click="funDialogSignaturePatient()">
                        <span v-if="!SignaturePatient && !SignaturePatientDB" style="height: 80px; width: 100%"></span>
                        <img :src="SignaturePatient" v-if="SignaturePatient" alt="Firma Paciente" style="
                            max-width: 100%;
                            height: 80px;
                            object-fit: contain;
                          " />
                        <img :src="SignaturePatientDB" v-if="!SignaturePatient && SignaturePatientDB"
                          alt="Firma Paciente" style="
                            max-width: 100%;
                            height: 80px;
                            object-fit: contain;
                          " />
                      </div>
                      <div style="
                          width: 60px;
                          height: 80px;
                          border: 1px solid #000;
                          text-align: center;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        ">
                        <!-- fingerPrintPatient, fingerPrintPatientDB -->
                        <s-finger-print v-if="FingerPrintPatientDB && !FingerPrintPatient" contentIMG
                          :srcImg="FingerPrintPatientDB" notBtn :stylesDiv="{
                            width: '60px',
                            height: '80px',
                            cursor: 'pointer',
                          }" @fingerprintSaved="handleFingerprintPatient" />
                        <s-finger-print v-if="!FingerPrintPatientDB && !FingerPrintPatient" contentIMG notBtn
                          :stylesDiv="{
                            width: '60px',
                            height: '80px',
                            cursor: 'pointer',
                          }" @fingerprintSaved="handleFingerprintPatient" />
                        <s-finger-print v-if="FingerPrintPatient" contentIMG :srcImg="FingerPrintPatient" notBtn
                          :stylesDiv="{
                            width: '60px',
                            height: '80px',
                            cursor: 'pointer',
                          }" @fingerprintSaved="handleFingerprintPatient" />
                      </div>
                    </div>
                  </div>
                  <span style="border-top: 1px solid #000">
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <span style="font-weight: bold">Nombre : </span>{{ history.NtpFullName }}&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                  <span><span style="font-weight: bold">DNI : </span>{{ history.PrsDocumentNumber }}</span>
                  <span><span style="font-weight: bold">Fecha : </span>{{ $fun.formatDateView(history.MevDate) }}</span>
                </div>
                <!-- </p> -->
              </div>
            </td>
            <td v-show="isDoctor" colspan="9" style="vertical-align: bottom; padding-bottom: 40px">
              <v-img v-if="SignatureImageDoctor != null" contain :src="SignatureImageDoctor" height="150"></v-img>
              <div style="
                  border-top: 1px solid black;
                  width: 60%;
                  margin: 0 auto;
                  text-align: center;
                  padding-top: 5px;
                ">
                SELLO Y FIRMA DEL MÉDICO
              </div>
            </td>
          </tr>
        </table>

        <!-- SECCIÓN OBSERVADO Y RESULTADOS -->
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px" v-show="isDoctor">
          <tr>
            <td style="width: 30%; vertical-align: top; padding: 5px">
              <table style="width: 100%; border-collapse: collapse">
                <tr>
                  <td class="subtitle" style="text-align: center">OBSERVADO</td>
                </tr>
                <tr>
                  <td style="
                      border: 1px solid black;
                      text-align: center;
                      padding: 5px;
                      height: 40px;
                    ">
                    <input type="radio" :value="4" v-model="history.MevStatus" :disabled="!isDoctor || isNurse" />
                  </td>
                </tr>
              </table>
            </td>
            <td style="width: 30%; vertical-align: top; padding: 5px"></td>
            <td style="width: 40%; vertical-align: top; padding: 5px">
              <table style="width: 100%; border-collapse: collapse">
                <tr>
                  <td class="subtitle" style="width: 33.33%; text-align: center">
                    APTO
                  </td>
                  <td class="subtitle" style="width: 33.33%; text-align: center">
                    APTO C/RESTRICCIÓN
                  </td>
                  <td class="subtitle" style="width: 33.34%; text-align: center">
                    NO APTO
                  </td>
                </tr>
                <tr>
                  <td style="
                      border: 1px solid black;
                      text-align: center;
                      padding: 5px;
                      height: 40px;
                    ">
                    <input type="radio" :value="1" v-model="history.MevStatus" :disabled="!isDoctor || isNurse" />
                  </td>
                  <td style="
                      border: 1px solid black;
                      text-align: center;
                      padding: 5px;
                      height: 40px;
                    ">
                    <input type="radio" :value="2" v-model="history.MevStatus" :disabled="!isDoctor || isNurse" />
                  </td>
                  <td style="
                      border: 1px solid black;
                      text-align: center;
                      padding: 5px;
                      height: 40px;
                    ">
                    <input type="radio" :value="3" v-model="history.MevStatus" :disabled="!isDoctor || isNurse" />
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        <table style="width: 100%; border-collapse: collapse">
          <tr v-if="Number(history.MevStatus) === 2">
            <td colspan="16" style="padding: 8px 0 4px 0">
              <v-row dense>
                <v-col cols="12" md="4">
                  <s-select-definition :def="1537" v-model="history.TypeRestrictionTimeMeasure"
                    label="Medida de tiempo de restricción" :disabled="!isDoctor || isNurse" />
                </v-col>
                <v-col cols="12" md="4">
                  <s-text v-model.number="history.RestrictionTimeValue" label="Cantidad de medida de tiempo"
                    type="number" min="1" outlined dense :disabled="!isDoctor || isNurse" />
                </v-col>
                <v-col cols="12" md="4">
                  <s-date v-model="history.MevDateRestriction" label="Fecha de restricción" type="date" outlined dense
                    :disabled="!isDoctor || isNurse || isContractLocked" />
                </v-col>
              </v-row>
            </td>
          </tr>
          <tr v-if="[2, 4].includes(Number(history.MevStatus))">
            <td colspan="16" style="padding: 0 0 8px 0">
              <v-checkbox v-model="history.MevLiftedObservation" :true-value="1" :false-value="0"
                label="Levantó observación" dense hide-details :disabled="!isDoctor || isNurse" />
            </td>
          </tr>
          <tr>
            <td colspan="16" style="text-align: right; padding-top: 16px">
              <v-btn v-show="isDoctor || isNurse" color="primary" dark small @click="save" style="min-width: 110px">
                <v-icon left small>fas fa-save</v-icon>
                Guardar
              </v-btn>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- Diálogo de firma paciente -->
    <v-dialog v-model="dialogSignaturePatient" max-width="800px" persistent>
      <v-card>
        <s-toolbar label="Firma del Paciente" dark color="#8e8f91" close @close="dialogSignaturePatient = false" />
        <v-container>
          <v-row>
            <v-col>
              <s-signature-pad ref="signaturePadPatient" style="height: 400px" wacom
                :wacomFullName="history.NtpFullName" @save-signature="handleSignaturePatient" />
              <!-- :wacom="true"
                :wacomFullName="history.NtpFullName"  -->
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Vista previa de anexos (similar a OC) -->
    <v-dialog v-model="previewDialog" max-width="900px">
      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>Vista Previa</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closePreview">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-0">
          <!-- Imágenes -->
          <v-img v-if="previewType === 'image'" :src="previewUrl" max-height="600" contain></v-img>

          <!-- PDFs -->
          <iframe v-else-if="previewType === 'pdf'" :src="previewUrl" width="100%" height="600px"
            frameborder="0"></iframe>

          <!-- Otros tipos -->
          <div v-else class="pa-4 text-center">
            <v-icon size="64" color="grey">mdi-file</v-icon>
            <p class="mt-4">No se puede previsualizar este tipo de archivo.</p>
            <v-btn color="primary" @click="downloadCurrentFile">
              <v-icon left>mdi-download</v-icon>
              Descargar
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import s_HistoryRecord from "../../../services/HumanResource/HistoryRecordService";
import SToolbarPerson from "../../../components/Utils/Person/sToolbarPerson";
import _sGenParam from "../../../services/General/ParameterService";
import sFingerPrint from "@/components/Utils/RecursosHm/sFingerPrint";
import DocumentHeaderControl from "@/components/Utils/DocumentHeaderControl";
import GenUploadFiles from "@/services/General/GenUploadFiles";
import _sHelper from "@/services/HelperService";
import s_PublicRecruitment from "@/services/HumanResource/RecruitmentMassive/HmnPublicRecruitmentService";

export default {
  name: "HistoryEditNew",
  components: { SToolbarPerson, sFingerPrint, DocumentHeaderControl },
  props: {
    pHistory: null,
    person: Object,
    lastHistory: Object,
  },
  data() {
    return {
      // loading: false,
      disabled: false,
      showAccidents: false,
      workingConditions: [],
      // Archivos de reevaluación (pueden ser múltiples)
      reevaluationFile: [],

      // Estado de subida de archivos
      uploadingFiles: false,
      uploadingCurrent: 0,
      uploadingTotal: 0,

      // Firma y huella del paciente (UI)
      SignaturePatient: null,
      FingerPrintPatient: null,
      SignaturePatientDB: null,
      FingerPrintPatientDB: null,
      dialogSignaturePatient: false,

      // Vista previa de anexos
      previewDialog: false,
      previewUrl: null,
      previewType: null,
      currentPreviewFile: null,

      // Encabezado editable (código / versión / fechas)
      headerForm: {
        codigo: "SIG-ST-SO-FR-003",
        version: "08",
        fechaCreacion: "28/10/2018",
        ultimaRevision: "14/07/2025",
        paginas: "1 de 2",
        anexo: "00",
      },
      headerAttributes: null,
      MevStatus: 1,
      saving: false,
      savingNotes: false,
      headerEditDialog: false,
      headerEditForm: {
        codigo: "",
        version: "",
        fechaCreacion: "",
        ultimaRevision: "",
        paginas: "",
        anexo: "",
      },
      SignatureImageDoctor: null,

      history: {
        MevID: 0,
        MevDate: "",
        MevTime: "",
        MevDocumentNumber: "",
        NtpID: null,
        NtpFullName: "",
        TypeSex: 1,
        NtpAge: 0,
        TypeCivilStatus: 1,
        TypeEducationLevel: 1,
        PrsDocumentNumber: "",
        MevPhoneNumber: "",
        AreID: null,
        AreName: "",
        PstID: null,
        PstName: "",
        MevExpQuantity: 0,
        TypeExpMesure: 1,

        //hijos
        MevChildLiving: 0,
        MevChildDead: 0,
        MevFetalDeaths: 0,
        MevChildAborted: 0,
        MevChildDepend: 0,

        //antecedentes
        MevIsAllergy: 0,
        MevFoodAllergy: 0,
        MevFoodAllergyText: "",
        MevMedicationAllergy: 0,
        MevMedicationAllergyText: "",
        MevIsTuberculosis: 0,
        MevIsChronicBronchitis: 0,
        MevIsSeizures: 0,
        MevIsDiabetes: 0,
        MevIsBloodPressure: 0,
        MevIsNeoplasm: 0,
        MevIsAsthma: 0,
        MevIsHepatitis: 0,
        MevIsEts: 0,
        MevDescriptionSurgery: "NIEGA",
        MevOtherPathology: "NIEGA",
        MevFamilyAntecedents: "NIEGA",
        MevObservationPathology: "NIEGA",
        MevDateFUR: "NIEGA",
        MevMAC: "NIEGA",

        MevSignaturePatient: null,
        MevFingerPrintPatient: null,

        //examen mental
        MevMentalPresentation: 1,
        MevMentalLucidity: 1,
        MevMentalPosture: 1,
        MevMentalThought: 1,
        MevMentalLanguage: 1,
        MevMentalPerception: 1,
        MevMentalPitch: 1,
        MevMentalMemory: 1,
        MevMentalArticulation: 0,
        MevMentalInteligence: 1,
        MevMentalOrientationTime: 1,
        MevMentalPsychologicalAnt: "NIEGA",
        MevMentalOrientationSpace: 1,
        MevMentalPsychiatricAnt: "NIEGA",
        MevMentalOrientationPerson: 1,

        //habitos nocivos
        //alcohol
        MevAlcoholType: 0,
        TypeAlcohol: null,
        TypeAlcoholFrequency: null,

        //tabaco
        MevTobaccoType: 0,
        TypeTobacco: null,
        TypeTobaccoFrequency: null,

        //accidentes
        MevAccident1: null,
        MevAccidentDescription1: "",
        MevAccidentYear1: null,
        MevAccidentDaysLost1: null,
        MevAccident2: null,
        MevAccidentDescription2: "",
        MevAccidentYear2: null,
        MevAccidentDaysLost2: null,

        //funciones biologicas
        TypeLevelAppetite: 1,
        TypeLevelThirst: 1,
        TypeLevelUrine: 1,
        TypeLevelDepositions: 1,
        TypeLevelSleep: 1,
        TypeLevelLostWeight: 1,

        //evaluacion medica
        MevHeartRate: 0,
        MevBreathingFrecuency: 0,
        MevTemperature: 0,
        MevOxygenSaturation: 0,
        MevPASistol: 0,
        MevPADiastol: 0,
        MevSize: 0,
        MevWeight: 0,
        MevBMI: 0,

        TypeAnamnesis: null,
        MevDescriptionAnamnesis: "",

        //agudeza visual
        MevVisualFarRight: null,
        MevVisualFarLeft: null,
        MevVisualFarRightLense: null,
        MevVisualFarLeftLense: null,
        MevVisualNearRight: null,
        MevVisualNearLeft: null,
        MevVisualNearRightLense: null,
        MevVisualNearLeftLense: null,

        //examen fisico
        MevPhysicalHead: 1,
        MevPhysicalSkin: 1,
        MevPhysicalEyes: 1,
        MevPhysicalNose: 1,
        MevPhysicalEars: 1,
        MevPhysicalMouth: 1,
        MevPhysicalChest: 1,
        MevPhysicalCardiovascular: 1,
        MevPhysicalAbdomen: 1,
        MevPhysicalGenitourinary: 1,
        MevPhysicalOsteomuscular: 1,
        MevPhysicalColumn: 1,
        MevPhysicalMembersUpper: 1,
        MevPhysicalHands: 1,
        MevPhysicalMembersLower: 1,
        MevPhysicalMarcha: 1,

        MevHeadDesc: "",
        MevSkinDesc: "",
        MevEyesDesc: "",
        MevNoseDesc: "",
        MevEarsDesc: "",
        MevMouthDesc: "",
        MevChestDesc: "",
        MevCardiovascularDesc: "",
        MevAbdomenDesc: "",
        MevGenitourinaryDesc: "",
        MevOsteomuscularDesc: "",
        MevColumnDesc: "",
        MevMemberUpperDesc: "",
        MevHandsDesc: "",
        MevMemberLowerDesc: "",
        MevMarchaDesc: "",

        TypeDiagnosis: null,
        MevDescriptionDiagnosis: "",
        MevDescriptionReevaluation: "",
        MevReevaluationFile: null,
        TypeRecommendations: null,
        MevRecommendations: "",

        MevHasRiskFactors: 0,
        MevRiskFactors: null,
        MevDescriptionRiskFactors: "",
        MevDiet: 0,
        MevPregnant: 0,

        UsrMedicID: 0,
        UsrNurseID: 0,

        MevStatus: 5,
        MevLiftedObservation: 0,
        TypeRestrictionTimeMeasure: null,
        RestrictionTimeValue: null,
        MevDateRestriction: null,
        SecStatus: 0,
        UsrCreateID: this.$store.getters.userId,
      },
      physicalExamSystems: [
        {
          label: "CABEZA Y CUELLO",
          checkField: "MevPhysicalHead",
          descField: "MevHeadDesc",
        },
        {
          label: "PIEL Y FANERAS",
          checkField: "MevPhysicalSkin",
          descField: "MevSkinDesc",
        },
        {
          label: "OJOS",
          checkField: "MevPhysicalEyes",
          descField: "MevEyesDesc",
        },
        {
          label: "NARIZ",
          checkField: "MevPhysicalNose",
          descField: "MevNoseDesc",
        },
        {
          label: "OÍDOS",
          checkField: "MevPhysicalEars",
          descField: "MevEarsDesc",
        },
        {
          label: "BOCA",
          checkField: "MevPhysicalMouth",
          descField: "MevMouthDesc",
        },
        {
          label: "TÓRAX Y PULMONES",
          checkField: "MevPhysicalChest",
          descField: "MevChestDesc",
        },
        {
          label: "CARDIOVASCULAR",
          checkField: "MevPhysicalCardiovascular",
          descField: "MevCardiovascularDesc",
        },
        {
          label: "ABDOMEN",
          checkField: "MevPhysicalAbdomen",
          descField: "MevAbdomenDesc",
        },
        {
          label: "AP. GENITOURINARIO",
          checkField: "MevPhysicalGenitourinary",
          descField: "MevGenitourinaryDesc",
        },
        {
          label: "AP. MUSCULO ESQUELÉTICO",
          checkField: "MevPhysicalOsteomuscular",
          descField: "MevOsteomuscularDesc",
        },
        {
          label: "COLUMNA VERTEBRAL",
          checkField: "MevPhysicalColumn",
          descField: "MevColumnDesc",
        },
        {
          label: "MIEMBROS SUPERIORES",
          checkField: "MevPhysicalMembersUpper",
          descField: "MevMemberUpperDesc",
        },
        {
          label: "MANOS Y UÑAS",
          checkField: "MevPhysicalHands",
          descField: "MevHandsDesc",
        },
        {
          label: "MIEMBROS INFERIORES",
          checkField: "MevPhysicalMembersLower",
          descField: "MevMemberLowerDesc",
        },
        {
          label: "MARCHA",
          checkField: "MevPhysicalMarcha",
          descField: "MevMarchaDesc",
        },
      ],
    };
  },
  computed: {
    isContractLocked() {
      return Number(this.history?.StatusInd || 0) === 2;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isDoctor() {
      try {
        return this.$fun.hasSpecialPermission("DOCTOR");
      } catch (e) {
        return false;
      }
    },
    isNurse() {
      try {
        return this.$fun.hasSpecialPermission("ENFERMERA");
      } catch (e) {
        return false;
      }
    },
    // Archivos de reevaluación ya guardados (en BD)
    reevaluationFiles() {
      if (!this.history || !this.history.MevReevaluationFile) return [];
      return this.history.MevReevaluationFile.split(";")
        .map((p) => p && p.trim())
        .filter((p) => !!p)
        .map((p) => {
          const lower = p.toLowerCase();
          const isImage = /\.(png|jpe?g|gif|webp)$/i.test(lower);
          const isPdf = /\.pdf$/i.test(lower);
          const isWord = /\.docx?$|\.rtf$/i.test(lower);
          return {
            path: p,
            name: p,
            isImage,
            isPdf,
            isWord,
          };
        });
    },
  },
  watch: {
    pHistory() {
      this.loadHistory();
    },
    person(newPerson) {
      if (this.pHistory || !newPerson) return;

      this.history.NtpID = newPerson.NtpID;
      this.history.PrsDocumentNumber = newPerson.PrsDocumentNumber;
      this.history.NtpFullName = newPerson.NtpFullName;
      this.history.TypeSex = newPerson.TypeSex;
      this.history.NtpAge = this.calculateAge(newPerson.NtpBirthDate);
      this.history.NtpBirthDate = newPerson.NtpBirthDate;
      this.history.AreID = newPerson.AreID;
      this.history.MevPhoneNumber = newPerson.NtpTelephone;

      this.getNumeration(this.history.PrsDocumentNumber);
    },
    "history.MevWeight"() {
      this.calculateBMI();
    },
    "history.MevSize"() {
      this.calculateBMI();
    },
    "history.MevStatus"(newValue) {
      if (Number(newValue) !== 2) {
        this.history.TypeRestrictionTimeMeasure = null;
        this.history.RestrictionTimeValue = null;
        this.history.MevDateRestriction = null;
      }
      if (![2, 4].includes(Number(newValue))) {
        this.history.MevLiftedObservation = 0;
      }
    },
    "history.PstID"(newValue) {
      this.onPositionChanged(newValue);
    },
  },
  created() {
    // Si se recibe person, inicializar los datos personales en history
    if (this.person) {
      this.history.NtpID = this.person.NtpID;
      this.history.PrsDocumentNumber = this.person.PrsDocumentNumber;
      this.history.NtpFullName = this.person.NtpFullName;
      this.history.TypeSex = this.person.TypeSex;
      this.history.NtpAge = this.calculateAge(this.person.NtpBirthDate);
      this.history.NtpBirthDate = this.person.NtpBirthDate;
      this.history.AreID = this.person.AreID;
      this.history.MevPhoneNumber = this.person.NtpTelephone;
      if (this.person.PrsDocumentNumber) {
        this.loadApplicantPostulation(this.person.PrsDocumentNumber);
      }
    }
    this.loadHistory();
    this.loadHeaderForm();
  },
  methods: {
    onAreaChanged(val) {
      this.history.PstID = null;
      this.history.PstName = "";
      this.workingConditions = [];
    },
    async onPositionChanged(val) {
      let pstId = null;
      if (val && (typeof val === "number" || typeof val === "string")) {
        pstId = val;
      }
      this.history.PstID = pstId;

      if (pstId) {
        try {
          const resp = await s_HistoryRecord.getWorkingConditions(pstId);
          this.workingConditions = resp.data || [];
        } catch (err) {
          console.error("Error fetching working conditions:", err);
          this.workingConditions = [];
        }
      } else {
        this.workingConditions = [];
      }
    },
    funDialogSignaturePatient() {
      this.dialogSignaturePatient = true;
    },
    funDialogSignatureConsent() {
      this.dialogSignatureConsent = true;
    },
    handleSignaturePatient(image) {
      this.SignaturePatient = image;
      this.dialogSignaturePatient = false;
    },
    handleSignatureConsent(image) {
      this.SignatureConsent = image;
      this.dialogSignatureConsent = false;
    },
    handleFingerprintPatient(image) {
      this.FingerPrintPatient = image;
    },
    // Detecta el tipo de archivo usando el content-type devuelto por el backend
    detectPreviewType(contentType, fallbackName) {
      const ct = (contentType || "").toLowerCase();
      if (ct.startsWith("image/")) return "image";
      if (ct.indexOf("pdf") !== -1) return "pdf";
      // Fallback por extensión solo si no viene content-type claro
      if (fallbackName) {
        const ext = fallbackName.split(".").pop().toLowerCase();
        if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
        if (ext === "pdf") return "pdf";
      }
      return "other";
    },
    async openReevaluationFile(file) {
      if (!file || !file.path) return;
      const fileName = file.path;
      this.currentPreviewFile = file;
      try {
        const result = await GenUploadFiles.getFileForPreview(
          "routeClinicHistories",
          fileName
        );
        if (!result) return;
        // Aquí usamos el content-type real que viene del backend (PDF de Word/Excel/PPT)
        this.previewType = this.detectPreviewType(result.contentType, fileName);
        this.previewUrl = result.url;
        this.previewDialog = true;
      } catch (e) {
        console.error(e);
        this.$fun.alert("Error al abrir el anexo.", "error");
      }
    },
    downloadCurrentFile() {
      if (!this.currentPreviewFile || !this.currentPreviewFile.path) return;
      GenUploadFiles.getFile(
        "routeClinicHistories",
        this.currentPreviewFile.path,
        false
      );
    },
    closePreview() {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
      }
      this.previewDialog = false;
      this.previewUrl = null;
      this.previewType = null;
      this.currentPreviewFile = null;
    },
    loadHistory() {
      // this.loading = true;
      try {
        if (this.pHistory != null) {
          // Cargar directamente los datos de la fila seleccionada (sin llamar a show antiguo)
          this.history = { ...this.history, ...this.pHistory };

          // Cargar firmas existentes
          if (this.history.MevSignaturePatient) {
            this.SignaturePatientDB = this.history.MevSignaturePatient;
          }

          if (this.history.MevFingerPrintPatient) {
            this.FingerPrintPatientDB = this.history.MevFingerPrintPatient;
          }

          if (this.history.MevSignatureConsent) {
            this.SignatureConsentDB = this.history.MevSignatureConsent;
          }

          // Normalizar flags booleanos: el CE trae bool y los checkboxes usan 0/1
          const boolFields = [
            "MevTobaccoType",
            "MevAlcoholType",
            "MevIsAllergy",
            "MevFoodAllergy",
            "MevMedicationAllergy",
            "MevIsTuberculosis",
            "MevIsChronicBronchitis",
            "MevIsSeizures",
            "MevIsDiabetes",
            "MevIsBloodPressure",
            "MevIsNeoplasm",
            "MevIsAsthma",
            "MevIsHepatitis",
            "MevIsEts",
            "MevPhysicalHead",
            "MevPhysicalSkin",
            "MevPhysicalEyes",
            "MevPhysicalNose",
            "MevPhysicalEars",
            "MevPhysicalMouth",
            "MevPhysicalChest",
            "MevPhysicalCardiovascular",
            "MevPhysicalAbdomen",
            "MevPhysicalGenitourinary",
            "MevPhysicalOsteomuscular",
            "MevPhysicalColumn",
            "MevPhysicalMembersUpper",
            "MevPhysicalHands",
            "MevPhysicalMembersLower",
            "MevPhysicalMarcha",
            "MevHasRiskFactors",
            "MevDiet",
            "MevPregnant",
            "MevLiftedObservation",
          ];
          boolFields.forEach((f) => {
            if (typeof this.history[f] === "boolean") {
              this.history[f] = this.history[f] ? 1 : 0;
            }
          });
          console.log(this.$fun.getUserInfo().NtpFullName);
          if (this.isDoctor) {
            GenUploadFiles.getFile(
              "routeSignatures",
              this.$fun.getUserInfo().NtpFullName,
              true
            )
              .then((base64) => {
                this.SignatureImageDoctor = base64;
              })
              .catch((error) =>
                console.error("Error al obtener imagen:", error)
              );
          }
          this.history.MevDate = this.getCurrentLocalDate();
          this.history.MevTime = this.getCurrentLocalTime();

          this.MevStatus = this.history.MevStatus;
          this.disabled = this.isContractLocked;

          if (this.history.PstID) {
            this.onPositionChanged(this.history.PstID);
          }

          if (this.isContractLocked) {
            this.$nextTick(() => {
              this.$fun.alert(
                "La historia clínica ya está enlazada a un contrato. Solo está disponible para consulta.",
                "warning"
              );
            });
          }
        } else {
          // Nueva historia: numeración y fecha/hora actuales
          this.history.MevDocumentNumber = ""; // Reset explícito antes de obtener nueva numeración
          this.history.MevDate = this.getCurrentLocalDate();
          this.history.MevTime = this.getCurrentLocalTime();

          // Si el listado ya tiene historias cargadas, usar la última como plantilla
          if (this.lastHistory) {
            this.applyTemplateFromLast(this.lastHistory);
          } else if (this.history.PrsDocumentNumber) {
            this.loadTemplateFromServer(this.history.PrsDocumentNumber);
          }

          // Obtener numeración nueva con manejo de error
          this.getNumeration(this.history.PrsDocumentNumber);
        }
      } catch (error) {
        console.error("Error al cargar datos del trabajador:", error);
        this.$fun.alert("Error al cargar los datos del trabajador", "error");
      } finally {
        // this.loading = false;
      }
    },

    selectInput(event) {
      event.target.select();
    },

    getCurrentLocalDate() {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, "0");
      const d = String(now.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },

    getCurrentLocalTime() {
      return new Date().toLocaleTimeString("en-US", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },

    async loadTemplateFromServer(PrsDocumentNumber) {
      try {
        const resp = await s_HistoryRecord.getLastHistory(PrsDocumentNumber);
        if (resp && resp.data) {
          this.applyTemplateFromLast(resp.data);
        } else {
          this.history.MevDateFUR = "NIEGA";
          this.history.MevMAC = "NIEGA";
          this.history.MevExpQuantity = 0;
          this.history.TypeExpMesure = 1;
          this.history.MevChildLiving = 0;
          this.history.MevChildDead = 0;
          this.history.MevFetalDeaths = 0;
          this.history.MevChildAborted = 0;
          this.history.MevChildDepend = 0;
        }
      } catch (e) {
        console.error("Error al obtener última historia clínica:", e);
      }
    },

    applyTemplateFromLast(source) {
      if (!source) return;

      const fieldsToCopy = [
        // Datos personales
        "NtpID",
        "NtpFullName",
        "TypeSex",
        "NtpAge",
        "NtpBirthDate",
        "TypeCivilStatus",
        "TypeEducationLevel",
        "PrsDocumentNumber",
        "MevPhoneNumber",
        "AreID",
        "AreName",
        "PstID",
        "PstName",
        "MevExpQuantity",
        "TypeExpMesure",
        "MevChildLiving",
        "MevChildDead",
        "MevFetalDeaths",
        "MevChildAborted",
        "MevChildDepend",
      ];

      fieldsToCopy.forEach((field) => {
        if (source[field] !== undefined) {
          this.history[field] = source[field];
        }
      });

      if (this.history.PstID) {
        this.onPositionChanged(this.history.PstID);
      }
    },

    async getNumeration(documentNumber) {
      try {
        const safeDocumentNumber = (
          documentNumber ||
          this.history.PrsDocumentNumber ||
          ""
        )
          .toString()
          .trim();

        if (!safeDocumentNumber) {
          this.history.MevDocumentNumber = "";
          return;
        }

        const resp = await s_HistoryRecord.getNumerationDocument(
          safeDocumentNumber,
          this.$fun.getUserID()
        );
        this.history.MevDocumentNumber = resp.data;
      } catch (e) {
        console.error("Error al obtener numeración de documento:", e);
      }
    },
    async returnPerson(person) {
      this.history.NtpID = person.NtpID;
      this.history.PrsDocumentNumber = person.PrsDocumentNumber;
      this.history.NtpFullName = person.NtpFullName;
      this.history.TypeSex = person.TypeSex;
      this.history.NtpAge = this.calculateAge(person.NtpBirthDate);
      this.history.NtpBirthDate = person.NtpBirthDate;
      this.history.AreID = person.AreID;
      const oldnumber = this.history.MevPhoneNumber;
      this.history.MevPhoneNumber = person.NtpTelephone || oldnumber;

      // Al seleccionar un nuevo DNI, intentar cargar su última historia como plantilla
      if (this.history.PrsDocumentNumber) {
        await this.loadTemplateFromServer(this.history.PrsDocumentNumber);
        await this.loadApplicantPostulation(this.history.PrsDocumentNumber);
        this.getNumeration(this.history.PrsDocumentNumber);
        //limpiar firmas
        this.SignaturePatient = null;
        this.FingerPrintPatient = null;
        this.SignaturePatientDB = null;
        this.FingerPrintPatientDB = null;
      }
    },
    async loadApplicantPostulation(documentNumber) {
      if (!documentNumber) return;
      try {
        const resp = await s_PublicRecruitment.getApplicantPosition(
          documentNumber,
          this.$fun.getUserID()
        );
        if (resp && resp.data) {
          const { AreID, PstID } = resp.data;
          if (AreID) {
            this.history.AreID = AreID;
          }
          if (PstID) {
            this.$nextTick(async () => {
              this.history.PstID = PstID;
              await this.onPositionChanged(PstID);
            });
          }
        }
      } catch (e) {
        console.error("Error al obtener postulación del postulante:", e);
      }
    },
    calculateAge(birthDate) {
      if (!birthDate) return "";
      let today = new Date();
      let birth = new Date(birthDate);
      let age = today.getFullYear() - birth.getFullYear();
      let m = today.getMonth() - birth.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      return age;
    },
    calculateBMI() {
      if (this.history.MevWeight > 0 && this.history.MevSize > 0) {
        // Size in cm to meters
        let sizeM = this.history.MevSize / 100;
        this.history.MevBMI = (
          this.history.MevWeight / (sizeM * sizeM).toFixed(2)
        ).toFixed(2);
      }
    },
    getBMIColor(bmi) {
      if (bmi < 18.5) return "blue";
      if (bmi < 25) return "green";
      if (bmi < 30) return "orange";
      return "red";
    },
    getBMIDescription(bmi) {
      if (bmi < 16.99) return "Muy Bajo peso";
      if (bmi < 17.99) return "Bajo peso";
      if (bmi < 24.99) return "Normal";
      if (bmi < 29.99) return "Sobrepeso";
      if (bmi < 34.99) return "Obesidad I";
      if (bmi < 39.99) return "Obesidad II";
      return "Obesidad III";
    },
    getPAColor(pasistol, padiastol) {
      if (pasistol < 140 && padiastol < 90) return "green";
      // if (pasistol >= 120 && ) return "orange";
      return "red";
    },
    getPADescription(pasistol, padiastol) {
      if (pasistol < 140 && padiastol < 90) return "Normal";
      // if (
      //   (pasistol <= 140) ||
      //   (padiastol < 90)
      // )
      //   return "Hipertensión Etapa I";
      if (pasistol >= 140 || padiastol >= 90) return "Hipertensión Etapa II";
      return "No Diagnosticada";
    },
    getFRColor(fr) {
      if (fr < 12) return "blue";
      if (fr <= 20) return "green";
      return "red";
    },
    getFRDescription(fr) {
      if (fr < 12) return "BRADIPNEA";
      if (fr <= 20) return "EUPNEA";
      return "TAQUIPNEA";
    },
    getFCColor(fc) {
      if (fc < 60) return "blue";
      if (fc <= 100) return "green";
      return "red";
    },
    getFCDescription(fc) {
      if (fc < 60) return "BRADICARDIA";
      if (fc <= 100) return "NORMOCARDIA";
      return "TAQUICARDIA";
    },
    getTEMPColor(temp) {
      if (temp < 36.5) return "#22E9FC";
      if (temp < 37.5) return "green";
      if (temp <= 37.9) return "#E2B70A";
      if (temp <= 39.9) return "orange";
      return "red";
    },
    getTEMPDescription(temp) {
      if (temp < 36.5) return "HIPOTERMIA";
      if (temp < 37.5) return "NORMOTERMIA";
      if (temp <= 37.9) return "FEBRÍCULA";
      if (temp <= 39.9) return "FIEBRE";
      return "HIPERTERMIA";
    },
    getSO2Color(so2) {
      if (so2 >= 95 && so2 <= 100) return "green";
      if (so2 >= 91 && so2 <= 94) return "orange";
      if (so2 >= 86 && so2 <= 90) return "red";
      if (so2 < 86) return "darkred";
    },
    getSO2Description(so2) {
      if (so2 >= 95 && so2 <= 100) return "NORMAL";
      if (so2 >= 91 && so2 <= 94) return "HIPOXIA LEVE";
      if (so2 >= 86 && so2 <= 90) return "HIPOXIA MODERADA";
      if (so2 < 86) return "HIPOXIA GRAVE";
      return "NO DETERMINADA";
    },

    // ===== Encabezado editable (código / versión / fechas) =====
    loadHeaderForm() {
      _sGenParam
        .listoptions({ Search: "PdfHClinicHistory" }, this.$fun.getUserID())
        .then((resp) => {
          if (resp.status === 200 && resp.data.length) {
            this.headerAttributes = resp.data[0];
            try {
              const parsed = JSON.parse(this.headerAttributes.PrmValue);
              this.headerForm = { ...this.headerForm, ...parsed };
            } catch (e) {
              console.error("Error parseando encabezado historia clínica", e);
            }
          }
        });
    },
    openHeaderEditModal() {
      if (!this.$fun.isAdmin()) return;
      this.headerEditForm = { ...this.headerForm };
      this.headerEditDialog = true;
    },
    saveHeaderForm() {
      const data = { ...(this.headerAttributes || {}) };
      data.PrmName = data.PrmName || "PdfHClinicHistory";
      data.PrmValue = JSON.stringify(this.headerEditForm);

      _sGenParam.save(data, this.$fun.getUserID()).then((resp) => {
        if (resp.status === 200) {
          this.headerForm = { ...this.headerEditForm };
          this.headerAttributes = data;
          this.headerEditDialog = false;
        }
      });
    },
    async save() {
      if (!this.isDoctor && !this.isNurse) {
        this.$fun.alert(
          "No tiene permisos para guardar la historia clínica.",
          "error"
        );
        return;
      }
      if (this.isContractLocked) {
        this.$fun.alert(
          "La historia clínica ya está enlazada a un contrato y no puede modificarse.",
          "warning"
        );
        return;
      }

      const isEmpty = (value) => {
        if (value === null || value === undefined) return true;
        if (Array.isArray(value) && value.length === 0) return true;
        if (typeof value === "string") {
          const trimmed = value.trim();
          if (trimmed === "") return true;
          // Detectar string que representa array vacío: "[]" o "[   ]"
          if (/^\[\s*\]$/.test(trimmed)) return true;
          // Detectar string que representa array con solo espacios o vacío: "[  ,  ]"
          try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed) && parsed.length === 0) return true;
          } catch (e) { }
        }
        return false;
      };
      // Validación física: si algún sistema está en falso, la descripción es obligatoria
      for (const item of this.physicalExamSystems) {
        if (
          this.history[item.checkField] == 0 &&
          isEmpty(this.history[item.descField])
        ) {
          this.$fun.alert(
            `Debe ingresar una descripción para "${item.label}" si está anormal.`,
            "warning"
          );
          // Hacer focus al input correspondiente
          this.$nextTick(() => {
            const ref = this.$refs[`descInput-${item.descField}`];
            if (Array.isArray(ref) && ref[0]) {
              ref[0].focus();
            } else if (ref && typeof ref.focus === "function") {
              ref.focus();
            }
          });
          return;
        }
      }
      if (
        this.isDoctor &&
        isEmpty(this.history.TypeAnamnesis) &&
        isEmpty(this.history.MevDescriptionAnamnesis)
      ) {
        this.$fun.alert("Debe ingresar Anamnesis", "warning");
        return;
      }

      //si es mujer y edad fertil, debe ingresar FUR
      if (
        this.history.TypeSex == 2 &&
        this.isDoctor &&
        (this.history.MevDateFUR == null ||
          (typeof this.history.MevDateFUR === "string" &&
            this.history.MevDateFUR.trim() === "")) /* ||
          !/[a-zA-Z]/.test(this.history.MevDateFUR) */
      ) {
        this.$fun.alert(
          "Debe ingresar Fecha de Última Regla para mujeres en edad fértil",
          "warning"
        );
        return;
      }

      if (
        this.isDoctor &&
        isEmpty(this.history.TypeDiagnosis) &&
        isEmpty(this.history.MevDescriptionDiagnosis)
      ) {
        this.$fun.alert("Debe ingresar Diagnósticos", "warning");
        return;
      }

      if (
        this.isDoctor &&
        isEmpty(this.history.TypeRecommendations) &&
        isEmpty(this.history.MevRecommendations)
      ) {
        this.$fun.alert("Debe ingresar Recomendaciones", "warning");
        return;
      }
      //validar alergias
      if (this.history.MevIsAllergy == 1) {
        if (
          !this.history.MevFoodAllergy &&
          !this.history.MevMedicationAllergy
        ) {
          this.$fun.alert(
            "Si marca Alergias, debe especificar al menos una (Alimentaria o Medicamentosa)",
            "warning"
          );
          return;
        }
        if (this.history.MevFoodAllergy && !this.history.MevFoodAllergyText) {
          this.$fun.alert("Debe especificar la alergia alimentaria", "warning");
          return;
        }
        if (
          this.history.MevMedicationAllergy &&
          !this.history.MevMedicationAllergyText
        ) {
          this.$fun.alert(
            "Debe especificar la alergia medicamentosa",
            "warning"
          );
          return;
        }
      }
      if (this.history.MevIsBloodPressure == 1) {
        if (this.history.MevPASistol == 0 || this.history.MevPADiastol == 0) {
          this.$fun.alert(
            "Si marca Antecedente de Hipertensión Arterial, debe ingresar PA Sistólica y Diastólica",
            "warning"
          );
          return;
        }
      }
      //saturacion entre 0 y 100
      if (
        this.history.MevOxygenSaturation < 0 ||
        this.history.MevOxygenSaturation > 100
      ) {
        this.$fun.alert(
          "La Saturación de Oxígeno debe estar entre 0 y 100",
          "warning"
        );
        return;
      }
      if (
        this.history.MevHasRiskFactors == 1 &&
        (!this.history.MevRiskFactors != [] ||
          this.history.MevRiskFactors.length === 0)
      ) {
        this.$fun.alert(
          "Si marca Factores de Riesgo, debe seleccionar al menos uno",
          "warning"
        );
        return;
      }
      //validar area de trabajo
      if (!this.history.AreID || this.history.AreID === 0) {
        this.$fun.alert("Debe seleccionar un Área de Trabajo", "warning");
        return;
      }

      if (Number(this.history.MevStatus) === 2) {
        if (!this.history.TypeRestrictionTimeMeasure) {
          this.$fun.alert(
            "Debe seleccionar la medida de tiempo de restricción para Apto con restricción",
            "warning"
          );
          return;
        }

        if (
          !Number.isInteger(Number(this.history.RestrictionTimeValue)) ||
          Number(this.history.RestrictionTimeValue) <= 0
        ) {
          this.$fun.alert(
            "Debe ingresar una cantidad de restricción entera mayor a 0",
            "warning"
          );
          return;
        }

        if (this.isDoctor && !this.history.MevDateRestriction) {
          this.$fun.alert(
            "Debe ingresar la fecha de restricción para Apto con restricción",
            "warning"
          );
          return;
        }
      } else {
        this.history.TypeRestrictionTimeMeasure = null;
        this.history.RestrictionTimeValue = null;
        this.history.MevDateRestriction = null;
      }

      if (![2, 4].includes(Number(this.history.MevStatus))) {
        this.history.MevLiftedObservation = 0;
      }

      // Validación de diagnósticos ya realizada arriba

      let validation = await this.$fun.alert(
        "¿Seguro de guardar los datos?",
        "question"
      );
      if (validation.isConfirmed) {
        this.history.UsrCreateID = this.$fun.getUserID();

        // Asignar firmas si se han modificado
        if (this.SignaturePatient) {
          this.history.MevSignaturePatient = this.SignaturePatient;
        }

        if (this.FingerPrintPatient) {
          this.history.MevFingerPrintPatient = this.FingerPrintPatient;
        }
        if (this.SignatureConsent) {
          this.history.MevSignatureConsent = this.SignatureConsent;
        }

        if (this.isDoctor) {
          this.history.UsrMedicID = this.$fun.getUserID();
        }

        if (this.isNurse) {
          this.history.UsrNurseID = this.$fun.getUserID();
        }
        // === Subida de archivos de reevaluación ===
        // 1) Partimos de los archivos ya registrados (si vienen de BD)
        let reevaluationPaths = [];
        if (this.history.MevReevaluationFile) {
          reevaluationPaths = this.history.MevReevaluationFile.split(";")
            .map((x) => x && x.trim())
            .filter((x) => !!x);
        }

        // 1.1) Evitar duplicados si ya hemos subido antes el mismo nombre
        const hasPath = (p) => reevaluationPaths.includes(p);

        // 2) Subir los nuevos archivos seleccionados en el v-file-input
        if (
          Array.isArray(this.reevaluationFile) &&
          this.reevaluationFile.length > 0
        ) {
          this.uploadingFiles = true;
          this.uploadingCurrent = 0;
          this.uploadingTotal = this.reevaluationFile.length;

          for (let i = 0; i < this.reevaluationFile.length; i++) {
            const file = this.reevaluationFile[i];
            if (!file) continue;

            // Si ya es un string (ruta ya guardada), solo la agregamos
            if (!file.name) {
              if (!hasPath(file)) {
                reevaluationPaths.push(file);
              }
              this.uploadingCurrent++;
              continue;
            }

            try {
              const doc = this.history.PrsDocumentNumber || "ND";
              const uniqueFileName = `MevReevaluation_${doc}_${Date.now()}_${i + 1
                }`;

              const respImg = await GenUploadFiles.upload(
                file,
                uniqueFileName,
                "routeClinicHistories",
                true
              );

              if (respImg && respImg.data && respImg.data.fileName) {
                if (!hasPath(respImg.data.fileName)) {
                  reevaluationPaths.push(respImg.data.fileName);
                }
              }
              this.uploadingCurrent++;
            } catch (uploadError) {
              this.uploadingFiles = false;
              this.$fun.alert(
                "Error al subir uno de los archivos de reevaluación.",
                "warning"
              );
              console.error(
                "Error al subir archivo de reevaluación",
                uploadError
              );
              return;
            }
          }

          this.uploadingFiles = false;
        }

        this.history.MevReevaluationFile =
          reevaluationPaths.length > 0 ? reevaluationPaths.join(";") : null;

        // Convertir selects múltiples (JSON "[1,2,5]" o string "1,2,5")
        // a formato "1,2,5" antes de enviar al backend (igual que DailyHoursReport).
        const toComma = (v) => {
          if (v === null || v === undefined || v === "") return "";
          if (Array.isArray(v)) return v.join(",");
          if (typeof v === "string") {
            try {
              const parsed = JSON.parse(v);
              if (Array.isArray(parsed)) return parsed.join(",");
            } catch (e) {
              // ya viene como "1,2,5" u otro string compatible
              return v;
            }
          }
          return v;
        };

        this.history.TypeDiagnosis = toComma(this.history.TypeDiagnosis);
        this.history.TypeRecommendations = toComma(
          this.history.TypeRecommendations
        );
        this.history.MevRiskFactors = toComma(this.history.MevRiskFactors);
        if (this.pHistory == null) {
          await s_HistoryRecord.store(this.history);
          this.$fun.alert("Guardado correctamente", "success");
          this.exitView();
        } else {
          await s_HistoryRecord.update(this.history);
          this.$fun.alert("Actualizado correctamente", "success");
          this.exitView();
        }
      }
    },
    async changeState(state) {
      this.history.MevStatus = state;
      await s_HistoryRecord.update(this.history);
      this.$fun.alert("Estado actualizado correctamente", "success");
      this.exitView();
    },
    printPDF() {
      const printableContent = this.$refs.printableContent;
      const printWindow = window.open("", "", "height=800,width=800");
      printWindow.document.write("<html><head><title>Historia Clínica</title>");
      printWindow.document.write(
        "<style>@media print { body { -webkit-print-color-adjust: exact; } .page { page-break-after: always; } }</style>"
      );
      printWindow.document.write("</head><body>");
      printWindow.document.write(printableContent.innerHTML);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.print();
    },
    exitView() {
      this.$emit("close");
    },
    validateHeartRate(val) {
      if (!val) return;
      let num = parseInt(val);
      if (val.toString().startsWith("1")) {
        if (num > 250) {
          this.history.MevHeartRate = 250;
          this.$fun.alert(
            "La frecuencia cardiaca no puede ser mayor a 250",
            "warning"
          );
        }
      }
    },
  },
};
</script>


<style scoped>
/* ==========================
   CONTENEDOR PRINCIPAL
   ========================== */
.formato-medico-container {
  background-color: #fff;
  padding: 12px;
  max-width: 900px;
  margin: 0 auto;
  overflow-x: hidden;
}

.formato-medico {
  font-family: Arial, sans-serif;
  font-size: 9pt;
  position: relative;
  line-height: 1.4;
}

/* ==========================
   PÁGINA
   ========================== */
.page {
  border: 1px solid #000;
  padding: 12px;
  margin-bottom: 16px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.08);
  background: white;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  overflow-x: auto;
}

/* ==========================
   TABLAS PRINCIPALES
   ========================== */
.header-table,
.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
  table-layout: fixed;
  min-width: 700px;
  /* Asegura un ancho mínimo para scroll horizontal */
}

.header-table td,
.data-table td {
  border: 1px solid #333;
  padding: 6px 4px;
  vertical-align: top;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* ==========================
   TÍTULOS Y SUBTÍTULOS
   ========================== */
.title {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  margin: 3px 0;
  line-height: 1.2;
}

.subtitle {
  font-size: 10pt;
  font-weight: bold;
  background-color: #e8f4f8;
  padding: 6px;
  margin-top: 8px;
  border: 1px solid #333;
  text-align: center;
}

.header-cell {
  font-weight: bold;
  background-color: #f0f0f0;
  text-align: center;
  padding: 6px 4px;
}

/* ==========================
   MARCA DE AGUA
   ========================== */
.watermark {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  opacity: 0.05;
  font-size: 80px;
  pointer-events: none;
  user-select: none;
  z-index: 1;
  color: red;
  font-weight: bold;
  white-space: nowrap;
}

/* ==========================
   INPUTS Y CONTROLES
   ========================== */
.input-clean {
  width: 100%;
  border: none;
  border-bottom: 1px dotted #999;
  outline: none;
  background: transparent;
  font-family: inherit;
  font-size: inherit;
  padding: 3px 2px;
  font-weight: bold;
  text-transform: uppercase;
  min-height: 20px;
}

.input-clean:focus {
  border-bottom: 2px solid #1976d2;
  background-color: #f0f8ff;
}

.small-input {
  width: 60px;
  text-align: center;
  min-width: 50px;
}

textarea.input-clean {
  resize: vertical;
  border: 1px dotted #999;
  min-height: 60px;
  padding: 4px;
}

/* ==========================
   CHECKBOXES Y RADIOS PERSONALIZADOS
   ========================== */
input[type="checkbox"],
input[type="radio"] {
  transform: scale(1.3);
  margin: 0 6px;
  vertical-align: middle;
  cursor: pointer;
}

.custom-checkbox {
  width: 20px;
  height: 20px;
  min-width: 20px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  border: 2px solid #d1d5db;
  border-radius: 4px;
  position: relative;
  transition: all 0.2s ease;
  background-color: #fee;
  border-color: #ef4444;
  flex-shrink: 0;
}

.custom-checkbox:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* X por defecto (cuando NO está marcado) */
.custom-checkbox::before,
.custom-checkbox::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px;
  height: 2px;
  background-color: #ef4444;
}

.custom-checkbox::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.custom-checkbox::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

/* Cuando está marcado: check azul */
.custom-checkbox:checked {
  background-color: #2563eb;
  border-color: #2563eb;
}

.custom-checkbox:checked::before {
  content: "";
  top: 3px;
  left: 7px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2.5px 2.5px 0;
  transform: rotate(45deg);
  background-color: transparent;
}

.custom-checkbox:checked::after {
  display: none;
}

/* Hover effects */
.custom-checkbox:not(:disabled):hover {
  border-color: #dc2626;
  background-color: #fecaca;
  transform: scale(1.1);
}

.custom-checkbox:checked:not(:disabled):hover {
  background-color: #1d4ed8;
  border-color: #1d4ed8;
}

/* ==========================
   RESPONSIVIDAD - TABLETS (768px - 1024px)
   ========================== */
@media (max-width: 1024px) {
  .formato-medico-container {
    padding: 8px;
    max-width: 100%;
  }

  .formato-medico {
    font-size: 8.5pt;
  }

  .page {
    padding: 8px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    /* Smooth scrolling en iOS */
  }

  .header-table,
  .data-table {
    font-size: 8pt;
    min-width: 650px;
    /* Reducido para tablets */
  }

  .header-table td,
  .data-table td {
    padding: 5px 3px;
  }

  .title {
    font-size: 14px;
  }

  .subtitle {
    font-size: 9pt;
    padding: 5px;
  }

  .watermark {
    font-size: 60px;
  }

  /* Mejora de inputs en tablet */
  .input-clean,
  textarea.input-clean,
  select {
    font-size: 14px;
    /* Tamaño táctil óptimo */
    padding: 6px 4px;
    min-height: 32px;
    /* Área táctil mínima */
  }

  .small-input {
    width: 50px;
    min-width: 45px;
  }

  /* Checkboxes y radios más grandes en tablet */
  input[type="checkbox"],
  input[type="radio"] {
    transform: scale(1.5);
    margin: 0 8px;
  }

  .custom-checkbox {
    width: 24px;
    height: 24px;
    min-width: 24px;
  }
}

/* ==========================
   RESPONSIVIDAD - MÓVILES (hasta 768px)
   ========================== */
@media (max-width: 768px) {
  .formato-medico-container {
    padding: 4px;
  }

  .formato-medico {
    font-size: 8pt;
  }

  .page {
    padding: 6px;
    margin-bottom: 10px;
  }

  .header-table,
  .data-table {
    font-size: 7.5pt;
    min-width: 600px;
  }

  .header-table td,
  .data-table td {
    padding: 4px 2px;
  }

  .title {
    font-size: 13px;
    margin: 2px 0;
  }

  .subtitle {
    font-size: 8.5pt;
    padding: 4px;
  }

  .watermark {
    font-size: 50px;
  }

  .input-clean,
  textarea.input-clean,
  select {
    font-size: 13px;
    padding: 5px 3px;
    min-height: 30px;
  }
}

/* ==========================
   RESPONSIVIDAD - MÓVILES PEQUEÑOS (hasta 480px)
   ========================== */
@media (max-width: 480px) {
  .formato-medico-container {
    padding: 2px;
  }

  .formato-medico {
    font-size: 7pt;
  }

  .page {
    padding: 4px;
    border-width: 1px;
  }

  .header-table,
  .data-table {
    font-size: 7pt;
    min-width: 550px;
  }

  .header-table td,
  .data-table td {
    padding: 3px 2px;
  }

  .title {
    font-size: 12px;
  }

  .subtitle {
    font-size: 8pt;
    padding: 3px;
  }

  .watermark {
    font-size: 40px;
  }
}

/* ==========================
   SCROLL HORIZONTAL MEJORADO
   ========================== */
.page::-webkit-scrollbar {
  height: 8px;
}

.page::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.page::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.page::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* ==========================
   UTILIDADES ADICIONALES
   ========================== */
.center-text {
  text-align: center;
}

/* Mejora de legibilidad en pantallas pequeñas */
@media (max-width: 768px) {

  b,
  strong {
    font-weight: 700;
  }

  /* Evitar que el texto se parta en lugares incómodos */
  .header-table td b,
  .data-table td b {
    white-space: nowrap;
  }
}

/* ==========================
   ESTILOS PARA IMPRESIÓN
   ========================== */
@media print {
  .formato-medico-container {
    padding: 0;
    max-width: 100%;
  }

  .page {
    border: none;
    box-shadow: none;
    margin: 0;
    padding: 10px;
    page-break-after: always;
    overflow: visible;
  }

  .page:last-child {
    page-break-after: auto;
  }

  .input-clean,
  textarea.input-clean {
    border: none;
    background: transparent;
  }

  .watermark {
    opacity: 0.08;
  }

  .header-table,
  .data-table {
    min-width: auto;
  }

  /* Ocultar scrollbars en impresión */
  .page::-webkit-scrollbar {
    display: none;
  }

  /* Asegurar que los checkboxes se vean en impresión */
  .custom-checkbox {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}

/* ==========================
   ACCESIBILIDAD
   ========================== */
/* Focus visible para navegación por teclado */
.input-clean:focus-visible,
textarea.input-clean:focus-visible,
.custom-checkbox:focus-visible {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

/* Mejorar contraste en modo oscuro del sistema */
@media (prefers-color-scheme: dark) {
  .page {
    background: white;
    /* Mantener fondo blanco para el formulario médico */
  }
}

/* ==========================
   ANIMACIONES SUTILES
   ========================== */
.input-clean,
textarea.input-clean,
.custom-checkbox {
  transition: all 0.2s ease;
}
</style>
